export const BRAND = {
  name: "ДЕЛИ С АЛИ",
  short: "Дели с Али",
  tagline: "Частные экскурсии по Индии с русскоговорящим гидом",
  guide: "Али",
  phone: "+91 89589 56564",
  phoneHref: "tel:+918958956564",
  email: "haiderali89589@gmail.com",
  emailHref: "mailto:haiderali89589@gmail.com",
  whatsappHref: "https://wa.me/918958956564?text=Здравствуйте,%20Али!%20Хочу%20забронировать%20экскурсию.",
  telegramHref: "https://t.me/privateindiaguidedtour",
  instagramHref: "https://www.instagram.com/privateindiaguidedtourss",
  vkHref: "https://vk.ru/privateindiaguideali",
};

// 24 renamed India / Delhi tours with verified Unsplash India photos.
const U = (id) =>
  `https://images.unsplash.com/photo-${id}?auto=format&fit=crop&w=1200&q=80`;

export const TOURS = [
  {
    id: "old-delhi-spices",
    title: "Старый Дели: пряности, рикши и голоса базаров",
    short: "Пешеходная авторская прогулка по улочкам Чандни-Чоук и Хари-Байоли.",
    duration: "4 часа",
    price: "от $50 / чел.",
    priceNote: "$100 за 1–2 человек, далее $50 с человека.",
    group: "1–20 чел.",
    city: "Дели",
    image: "https://customer-assets.emergentagent.com/job_seo-tour-guide/artifacts/qna8uvvb_IMG_20251018_124856501~2.webp",
    description:
      "Пешеходная авторская прогулка по улочкам Чандни-Чоук и Хари-Байоли, где узкие переулки Старого Дели дышат XVII веком. Русскоговорящий гид ведёт вас туда, куда не проедет ни один автобус — к живым лавкам специй, крышам мечетей и мастерам параthа, о которых знают только местные.",
    program: [
      { title: "Крупнейший рынок специй Кхари-Баоли", desc: "Крупнейший в Азии рынок специй с XVII века. Ароматы кардамона, гвоздики, шафрана и сотен видов чили в мешках размером с человека. Пробуем, нюхаем, узнаём, чем настоящая гарам-масала отличается от подделки." },
      { title: "Мечеть Джама-Масджид со смотровой площадки", desc: "Крупнейшая мечеть Индии, построенная Шах-Джаханом. Поднимаемся на южный минарет и получаем лучшую панораму лабиринта старого города — красные крыши, купола и велорикши до горизонта." },
      { title: "Рикша сквозь лабиринт Чандни-Чоук", desc: "Эмоциональные 45 минут на велорикше по улицам, где не проедет даже машина. Живое сердце могольского Дели: лавки серебра, свадебные шоу, склады специй — всё вплотную." },
      { title: "Чай и парантха у местного мастера (по желанию)", desc: "Знаменитая параthа-гали, где четыре поколения жарят фирменные лепёшки с 12 начинками — от паneer до редиса и чили. Финальный горячий масала-чай." },
    ],
    highlights: [
      "Крупнейший рынок специй Кхари-Баоли",
      "Мечеть Джама-Масджид со смотровой площадки",
      "Рикша сквозь лабиринт Чандни-Чоук",
      "Чай и парантха у местного мастера",
    ],
    includes: [
      "Встреча в отеле и трансфер в отель",
      "Машина с кондиционером",
      "Русскоговорящий гид",
      "Рикша",
      "Дегустация уличной еды",
      "Все входные билеты",
    ],
  },
  {
    id: "taj-sunrise",
    title: "Тадж-Махал на рассвете: тур из Дели за один день",
    short: "Экспресс-выезд в Агру: успеть увидеть, как солнце окрашивает мрамор в розовый.",
    duration: "14 часов",
    price: "от $75 / чел.",
    priceNote: "$150 за 1–2 человек, далее $75 с человека.",
    group: "1–20 чел.",
    city: "Агра",
    image: U("1564507592333-c60657eea523"),
    description:
      "Экспресс-выезд в Агру: успеть увидеть, как солнце окрашивает мрамор Тадж-Махала в кораллово-розовый. Русскоговорящий гид Али сопровождает вас лично — от встречи в отеле до возвращения в Дели поздним вечером. Формат приватный: только вы, ваш темп, живой рассказ о Моголах и любви Шах-Джахана.",
    program: [
      { title: "Рассвет у Тадж-Махала без толпы", desc: "Вход открывается за 30 минут до восхода. Мрамор меняет цвет от лунно-серого до кораллово-розового за 40 минут — уникальный оптический эффект, который невозможно поймать днём." },
      { title: "Красный форт Агры", desc: "Крепость Моголов из красного песчаника, где Шах-Джахан провёл последние 8 лет жизни в заключении, глядя на Тадж-Махал через окно восьмиугольной башни Мусамман-Бурдж." },
      { title: "Завтрак в отеле Агры", desc: "Полноценный завтрак-buffet в отеле 4★ с прямым видом на Тадж-Махал через реку Ямуна — идеальная передышка перед обратной дорогой." },
      { title: "Возвращение в Дели", desc: "Комфортный обратный путь по 6-полосному Ямуна-экспрессу, вечерний трансфер до вашего отеля в Дели." },
    ],
    highlights: [
      "Рассвет у Тадж-Махала без толпы",
      "Красный форт Агры",
      "Завтрак в отеле Агры",
      "Возвращение в Дели вечером",
    ],
    includes: [
      "Встреча в отеле и трансфер в отель",
      "Комфортный автомобиль с кондиционером",
      "Завтрак",
      "Русскоговорящий гид",
    ],
  },
  {
    id: "golden-triangle-3d",
    title: "Золотой треугольник за 3 дня: Дели · Агра · Джайпур",
    short: "Классика Северной Индии в лучшем ритме — авторский маршрут Али.",
    duration: "3 дня / 2 ночи",
    price: "$799 / чел.",
    priceNote: "Фиксированная цена $799 с человека — групповой формат.",
    group: "1–20 чел.",
    city: "Дели · Агра · Джайпур",
    image: "https://customer-assets.emergentagent.com/job_seo-tour-guide/artifacts/4bu7z4nc_IMG_20251230_091302340~2.webp",
    description:
      "Откройте для себя сердце Индии — три легендарных города, где древние легенды встречаются с яркой современной жизнью. Продуманный маршрут без суеты: лучшие отели 3★, кондиционированный транспорт, русскоязычный гид-проводник, который знает город изнутри. За три дня — рассвет у Тадж-Махала, подъём на слоне к форту Амбер, живые ремёсла Моголов и настоящая раджастанская музыка на прощальном ужине.",
    longDescription: [
      "### Почему именно этот тур",
      "Без суеты, с комфортом: продуманный маршрут, отели 3★, кондиционированный транспорт. Русскоязычный гид-проводник: живые истории, скрытые уголки и настоящая Индия не из путеводителей. Экспресс-формат: максимум впечатлений за 3 дня / 2 ночи — идеально для первого знакомства.",
      "### Ключевые моменты",
      "Тадж-Махал на рассвете — символ вечной любви в мистической тишине утра, окрашенный первыми лучами в розовое золото. Королевский подъём на слоне к форту Амбер — как настоящий властитель Раджастана. Хаос и цвет Старого Дели — лабиринты Чандни-Чоук, коктейль ароматов (жасмин, специи, street food) и крики торговцев. Тайны могольских дворцов в Агра-форте: трон павлинов, тайные переходы и вид на Тадж-Махал из окон Мусамман-Бурдж.",
      "### Архитектурные чудеса Розового города",
      "Дворец Ветров (Хава-Махал) с его 953 окнами и загадочная астрономическая обсерватория Джантар-Мантар. Прощальный ужин под звуки живой раджастанской музыки и танцы с развевающимися шарфами — эмоциональный финал, проникновение в душу региона.",
    ],
    program: [
      {
        title: "День 1 · Дели: традиционная встреча и погружение в столицу",
        desc: "В аэропорту вас встречает ослепительная гирлянда из свежих бархатцев и белого жасмина — первый вдох Индии. Старый Дели: узкие улочки Чандни-Чоук, гудки рикш, крики торговцев, ароматы специй и лепёшек. Суровые стены Красного форта и минареты Джама-Масджид, откуда открывается вид на старый город. Новый Дели: тенистые проспекты Раджпатх, белоснежный Храм Лотоса, монументальные Ворота Индии. Секретный лайфхак от гида — ресторан с лучшим баттер-чикеном в стране. Вечером — переезд в Агру.",
      },
      {
        title: "День 2 · Агра: Тадж-Махал на рассвете и мастерские Моголов",
        desc: "Рассвет у Тадж-Махала: первые лучи скользят по белому мрамору, мавзолей отражается в водном канале, легенда о Шах-Джахане и Мумтаз-Махал. Мощные красные стены Агра-форта: Трон Павлинов в Диван-и-Ам, тайные переходы гарема, окна Мусамман-Бурдж с видом на Тадж-Махал. Мастер-класс: ювелиры Моголов (техники кундан и минакари) и искусство пьетра-дура — вкладываем полудрагоценные камни в мрамор. Переезд в Джайпур сквозь живописные деревни и чайные плантации.",
      },
      {
        title: "День 3 · Джайпур: восхождение на слоне и обсерватория махараджей",
        desc: "Форт Амбер: плавный подъём на слонах к вратам крепости цвета закатной охры. Зеркальный дворец Шиш-Махал, отражения в озере Маота. Хава-Махал — ажурный фасад с 953 окнами-джали. Джантар-Мантар — гигантские каменные астрономические инструменты XVIII века: солнечные часы Самрат-Янтра с математической точностью. Храм обезьян Галтаджи в горном ущелье. Прощальный ужин под живую раджастанскую музыку.",
      },
    ],
    highlights: [
      "День 1: Старый и Новый Дели, встреча с гирляндой бархатцев",
      "День 2: Рассвет у Тадж-Махала, Агра-форт, мастерские Моголов",
      "День 3: Форт Амбер на слонах, Хава-Махал, Джантар-Мантар, храм Галтаджи",
    ],
    includes: [
      "Отели 3★ с завтраками",
      "Кондиционированный автомобиль на все дни",
      "Русскоговорящий гид на весь маршрут",
      "Все входные билеты",
      "Прощальный ужин с живой раджастанской музыкой",
      "Все переезды Дели — Агра — Джайпур — Дели",
    ],
  },
  {
    id: "delhi-first-look",
    title: "Первое знакомство с Дели: обзорная на автомобиле",
    short: "Ключевые точки столицы за один день — идеально для первого визита в Индию.",
    duration: "6 часов",
    price: "от $55 / чел.",
    priceNote: "$135 за 1–2 человек, далее $55 с человека.",
    group: "1–20 чел.",
    city: "Дели",
    image: "/img/lotus-delhi.webp",
    description:
      "Ключевые точки столицы за один день — идеально для первого визита в Индию. Русскоговорящий гид Али сопровождает вас лично — от встречи в отеле до возврата. Никаких групп из автобуса: только ваш темп, ваши интересы и живой рассказ о культуре, истории и повседневной жизни Индии.",
    program: [
      { title: "Ворота Индии и Раджпатх", desc: "«Триумфальная арка Индии» высотой 42 м в память о 90 000 индийских солдат, погибших в Первой мировой. Вечный огонь Amar Jawan Jyoti. Раджпатх — 2,5-километровая парадная ось от президентского дворца до ворот." },
      { title: "Мавзолей Хумаюна, Красный форт, Кутб-Минар", desc: "Три памятника-символа могольской эпохи: мавзолей Хумаюна 1570 года — прообраз Тадж-Махала; императорский Красный форт из красного песчаника (1648) с покоями Мумтаз; и Кутб-Минар — старейший минарет Индии (73 м, XII век)." },
      { title: "Храм Лотоса Бахаи", desc: "Одно из самых фотографируемых зданий мира — 27 мраморных лепестков вокруг центрального молитвенного зала. Единственный храм в Дели, открытый для всех религий одновременно." },
      { title: "Гурудвара Бангла-Сахиб, ступенчатый колодец", desc: "Сикхский храм с золотым куполом на месте, где остановился 8-й гуру Хар Кришан. Священный «сарова» — пруд, вода которого, по преданию, исцеляет. Рядом Аграсен-Ки-Баоли — 60-метровый колодец XIV века с 108 ступенями." },
    ],
    highlights: [
      "Ворота Индии и Раджпатх",
      "Мавзолей Хумаюна, Красный форт, Кутб-Минар",
      "Храм Лотоса Бахаи",
      "Гурудвара Бангла-Сахиб, ступенчатый колодец",
    ],
    includes: [
      "Встреча в отеле Дели",
      "Автомобиль с кондиционером",
      "Услуги русскоговорящего гида",
      "Входные билеты",
      "Бутылочная вода в машине",
      "Все дорожные сборы, налоги, парковки и бензин",
      "Трансфер в отель",
    ],
  },
  {
    id: "varanasi-ganges",
    title: "Мистический Варанаси: ритуалы на Ганге",
    short: "Древнейший живой город мира — рассветная лодка и вечерняя аарти.",
    duration: "2 дня / 1 ночь",
    price: "от $245 / чел.",
    priceNote: "$490 за 1–2 человек, далее $245 с человека.",
    city: "Варанаси",
    group: "1–20 чел.",
    image: "https://customer-assets.emergentagent.com/job_seo-tour-guide/artifacts/76educi1_IMG-20230720-WA0018.jpg",
    description:
      "Древнейший непрерывно населённый город мира (3000 лет) и главное духовное место индуизма. Русскоговорящий гид сопровождает вас лично — от встречи в аэропорту Дели в 4 утра до возврата вечером второго дня. Формат приватный: ваш темп, ваши интересы и погружение в жизнь у Ганга, которую невозможно описать словами.",
    program: [
      { title: "Вечерний Ганга-аарти в Дашашвамедх-гхат", desc: "Огненная церемония поклонения реке Ганге у главного гхата Варанаси. Семь брахманов синхронно поднимают многоуровневые лампы-дии в такт мантрам и барабанам. Смотрим с лодки на воде — уникальный ракурс, недоступный с берега." },
      { title: "Прогулка по старому городу", desc: "Лабиринт узких улочек XVI века вокруг храма Каши-Вишванатха. Живые дхаба, священные быки, паломники со всей Индии, тысячи маленьких храмов на каждом углу. Рассказ о варнасрам-дхарме и почему индусы приезжают сюда умирать." },
      { title: "Сарнатх — место первой проповеди Будды", desc: "В 10 км от Варанаси — олений парк Сарнатх, где 2500 лет назад Будда прочитал первую проповедь. Ступа Дхамек, монастырь Мулагандха-Кути-Вихара, музей с царской колонной Ашоки — тем самым «львом», что стал гербом Индии." },
    ],
    organizational: [
      "Встреча в аэропорту Дели в 4:00 утра",
      "Скоростной поезд отправляется в 6:00 утра, завтрак и обед подают в поезде",
      "Билеты на поезд включены в стоимость — туда-обратно, второй класс вагона",
      "В Варанаси вас встретит наш представитель с табличкой у вашего вагона",
      "Небольшой отдых после размещения в отеле",
      "Из отеля в старый город переезд на рикше",
      "Огненную молитву у берега реки вы увидите с лодки, включая другие гхаты и храмы",
    ],
    highlights: [
      "Вечерний Ганга-аарти в Дашашвамедх-гхат",
      "Прогулка по старому городу",
      "Сарнатх — место первой проповеди Будды",
    ],
    includes: [
      "Скоростной поезд туда-обратно с завтраком и обедом",
      "Проживание в 3★ отеле в двухместном номере с завтраком",
      "Русскоговорящий гид",
      "Лодка и входные билеты",
    ],
  },
  {
    id: "pink-jaipur",
    title: "Розовый Джайпур: дворцы, форты и слоны",
    short: "Раджастанская столица за один насыщенный день.",
    duration: "12 часов",
    price: "от $85 / чел.",
    priceNote: "$170 за 1–2 человек, далее $85 с человека.",
    city: "Джайпур",
    group: "1–20 чел.",
    image: U("1599661046289-e31897846e41"),
    description:
      "Раджастанская столица за один насыщенный день: розовые стены XVIII века, форт-крепость на скале, дворец с 953 окнами и обсерватория, где солнечные часы работают до сих пор. Русскоговорящий гид ведёт вас лично — от встречи в Дели до возврата. Формат приватный, никаких групп из автобуса.",
    program: [
      { title: "Форт Амбер и панорама города", desc: "Крепость XVI века на скале над озером Маота, столица Раджпутов до 1727 года. Внутри — зеркальный дворец Шиш-Махал, зал общих приёмов Диван-и-Ам, гарем с 12 покоями для жён махараджи и потрясающая панорама Джайпура." },
      { title: "Дворец Ветров Хава-Махал и Дворец на воде", desc: "Ажурный пятиэтажный фасад Хава-Махала с 953 окнами-джали, через которые женщины гарема наблюдали за жизнью города. Плюс Джал-Махал — «дворец на воде» посреди озера Мансагар, наполовину затопленный по замыслу махараджи." },
      { title: "Городской дворец и Джантар-Мантар", desc: "Действующая резиденция махараджей Джайпура с музеем-текстилём и оружейным залом. Рядом — обсерватория Джантар-Мантар XVIII века, где 19 гигантских каменных инструментов до сих пор точно измеряют время и положение звёзд. Объект ЮНЕСКО." },
      { title: "Обед в раджпутском ресторане (по желанию)", desc: "Классические блюда Раджастана: дал-бати-чурма, ласи-мисси-роти, гхевар (сладкий десерт). Некоторые рестораны с живой музыкой и танцем гхумар — характерным для региона." },
      { title: "Деревня слонов (по желанию)", desc: "Этичная слоновья деревня «Elefantastic» — не катание, а знакомство: кормите, купаете, рисуете на коже растительными красками. Основана в 2012 году, работает по стандартам защиты животных." },
    ],
    highlights: [
      "Форт Амбер и панорама города",
      "Дворец Ветров Хава-Махал и дворец на воде",
      "Городской дворец и Джантар-Мантар",
      "Обед в раджпутском ресторане (по желанию)",
      "Деревня слонов (по желанию)",
    ],
    includes: [
      "Встреча в отеле Дели и трансфер в отель Дели",
      "Автомобиль с кондиционером",
      "Все участки дорог, налоги, парковки и бензин",
      "Русскоговорящий гид",
    ],
  },
  {
    id: "delhi-street-food",
    title: "Гастротур по Дели: уличная еда без страха",
    short: "Дегустации в проверенных местах — от паан до бирьяни.",
    duration: "3 часа",
    price: "от $55 / чел.",
    priceNote: "$100 за 1–2 человек, далее $55 с человека.",
    city: "Дели",
    group: "1–20 чел.",
    image: U("1596040033229-a9821ebd058d"),
    description:
      "Дегустации в самых проверенных местах Старого Дели — от паан до бирьяни. Русскоговорящий гид сопровождает вас лично: показывает мастеров с 4–5 поколениями за плечами, объясняет, что есть безопасно и как. Никаких групп из автобуса — только ваш темп и живой рассказ о повседневной жизни Индии.",
    program: [
      { title: "Легендарная параthа-гали", desc: "Узкий переулок «улица параthа» в старом Дели, где 4 поколения жарят лепёшки с 12 начинками: паneer, картофель, редис, чили, чечевица, орех. Стоимость — 30 рупий за штуку." },
      { title: "Джалеби и рабри в старом Дели", desc: "Знаменитый ресторан «Old Famous Jalebi Wala» работает с 1884 года. Свежая горячая джалеби в шафрановом сиропе + сгущённая рабри — сочетание, которое ставит в тупик всех международных шеф-поваров." },
      { title: "Кебабы Каримс и чикен-тикка", desc: "Легендарный «Каримс» у Джама-Масджид работает с 1913 года. Владелец — потомок повара императора Бабура. Секретные специи и мангал на углях, курица тандури — та самая, оригинальная." },
      { title: "Масала-чай и паан по традиции", desc: "Крепкий чай с кардамоном, имбирём и гвоздикой + свёрнутый в бетелевый лист паан с гулкандом, серебряной фольгой и специями — традиционный десерт-освежитель, которому 2000 лет." },
    ],
    highlights: [
      "Легендарная параthа-гали",
      "Джалеби и рабри в старом Дели",
      "Кебабы Каримс и чикен-тикка",
      "Масала-чай и паан по традиции",
    ],
    includes: [
      "Встреча в отеле и трансфер в отель",
      "Дегустации",
      "Русскоговорящий гид",
      "Питьевая бутылочная вода в машине",
    ],
  },
  {
    id: "delhi-night",
    title: "Ночной Дели: базары, лунный свет и чай",
    short: "Совсем другой город — когда включаются гирлянды и жаровни.",
    duration: "4 часа",
    price: "от $65 / чел.",
    priceNote: "от $135 за 1–2 человек, далее $65 с человека.",
    city: "Дели",
    group: "1–20 чел.",
    image: "https://customer-assets.emergentagent.com/job_seo-tour-guide/artifacts/7lobm61r_IMG_20240303_195715616.webp",
    description:
      "Совсем другой город — когда включаются гирлянды, жаровни и подсветка правительственных зданий. Русскоговорящий гид сопровождает вас лично — от встречи в отеле до возврата. Ваш темп, ваши интересы и рассказ о ночной жизни столицы, которую никогда не увидит дневная группа.",
    program: [
      { title: "Ворота Индии в подсветке", desc: "«Триумфальная арка Индии» 42 м в вечерней иллюминации. Вечный огонь Amar Jawan Jyoti горит в память о погибших воинах. Летние вечера — семейное место для местных." },
      { title: "Ночной Новый Дели", desc: "Освещённый Раджпатх, здание парламента, дом президента и правительственные кварталы Лутиенского Дели в мягкой золотой подсветке — совсем другая столица, чем днём." },
      { title: "Мечеть Джама-Масджид в темноте", desc: "Мечеть закрывается для туристов после захода, но силуэт красного песчаника и белого мрамора в темноте — один из самых красивых кадров Дели. Тишина после дневного гула базара." },
      { title: "Кулфи и ласси", desc: "Плотное индийское мороженое-кулфи с шафраном и фисташками + свежий йогурт-ласси с розовой водой у уличных мастеров, обучающихся ремеслу от отца к сыну." },
    ],
    highlights: [
      "Ворота Индии в подсветке",
      "Ночной Новый Дели",
      "Мечеть Джама-Масджид в темноте",
      "Кулфи и ласси",
    ],
    includes: [
      "Встреча в отеле и трансфер в отель",
      "Автомобиль с кондиционером",
      "Русскоговорящий гид",
      "Дегустации",
      "Питьевая бутылочная вода в машине",
    ],
  },
  {
    id: "sari-photoshoot",
    title: "Фотосессия в сари: индийская сказка в кадре",
    short:
      "Наряд, стилист, локации — привезите домой настоящую обложку журнала. Русскоговорящий гид Али сопровождает вас лично: от отеля в Дели до салона сари в Агре и рассветной съёмки у Тадж-Махала.",
    duration: "10 часов",
    price: "$190 до 2 чел., далее $90 с человека",
    priceNote: "$190 за поездку до 2 человек включительно. При компании от 3 человек — по $90 с каждого дополнительного гостя.",
    city: "Дели · Агра",
    group: "1–20 чел.",
    image: "https://customer-assets.emergentagent.com/job_seo-tour-guide/artifacts/off24jmj_IMG_20251021_163724578.webp",
    description:
      "Проживите один день как героиня индийской легенды. Мы забираем вас из отеля в Дели, везём в Агру, подбираем сари вашего цвета в старинном салоне, где четыре поколения одной семьи наряжают невест, и устраиваем полноценную фотосессию у самого романтичного памятника планеты — Тадж-Махала. Никакой суеты и групп с автобусов: только вы, стилист, гид Али и лучшие ракурсы, которые знают только местные.",
    longDescription: [
      "### Что делает эту фотосессию особенной",
      "Настоящее сари — не сувенирная накидка, а полноценные 5,5 метров шёлка с расшитой каймой. Стилист покажет, как красиво завернуть паллу, поможет с бинди, браслетами и цветами в волосы. Всё аутентично, без бутафории.",
      "### Локации, которые запомнятся",
      "Тадж-Махал в рассветном свете, когда мрамор из белого становится сначала розовым, а потом персиковым. Красные стены Аграского форта — идеальный контраст с ярким сари. По желанию — Мехтаб-Баг с видом на Тадж через реку Ямуну для «зеркальных» кадров.",
      "### Кому подходит",
      "Девичники, годовщины, дни рождения, соло-путешественницы, мамы с дочками. Тур одинаково хорош и для двоих подруг, и для большой компании — цена честно уменьшается с каждым дополнительным человеком.",
    ],
    program: [
      { title: "07:00 · Встреча в отеле и выезд в Агру", desc: "Утренний выезд из вашего отеля в Дели на комфортабельном автомобиле с кондиционером. Около 3 часов в дороге — Али расскажет о культуре сари, символах цветов и о том, как индийские женщины носят традиционный наряд каждый день." },
      { title: "10:30 · Салон сари в Агре", desc: "Приезд в семейный салон. Сотни сари всех оттенков — от нежно-розовых до глубоких бордовых с золотой каймой. Стилист поможет подобрать цвет под ваш тип внешности, красиво завернёт ткань, добавит бинди, браслеты и живые цветы в волосы." },
      { title: "11:30 · Фотосессия у Тадж-Махала", desc: "Заход в комплекс через восточные ворота. Профессиональный фотограф работает вместе с Али: подсказываем позы, находим лучшие ракурсы, ловим свет. От классических кадров у главного мавзолея до художественных — в арках и у водного канала." },
      { title: "13:30 · Аграский форт из красного песчаника", desc: "Продолжение съёмки на фоне красных стен форта Великих Моголов. Идеальный контраст: яркое сари против терракотовых стен, дворцовые арки, ажурные решётки." },
      { title: "14:30 · Обед в ресторане с видом на Тадж", desc: "Отдых, смена образа обратно на дорожную одежду и традиционный индийский обед — тхали, наан, панир, десерт. По желанию — короткий заезд в мастерскую пиетра-дура (мраморная инкрустация)." },
      { title: "16:00 · Возвращение в Дели", desc: "Комфортабельный трансфер обратно. Прибытие в отель или аэропорт около 19:00. Фото передаются в течение 3 дней в облачную папку." },
    ],
    highlights: [
      "Настоящее шёлковое сари с помощью стилиста",
      "Профессиональная фотосессия у Тадж-Махала на рассветном свете",
      "Красные стены Аграского форта — второй фото-локейшн",
      "Живые цветы, бинди и браслеты в подарок",
      "Приватный формат — только ваша компания",
    ],
    includes: [
      "Встреча в вашем отеле в Дели",
      "Автомобиль с кондиционером и питьевая вода",
      "Профессиональный русскоговорящий гид и водитель",
      "Аренда сари, услуги стилиста, аксессуары",
      "Услуги профессионального фотографа (100+ обработанных кадров)",
      "Все дороги, налоги, парковки, бензин",
      "Индивидуальный трансфер по окончании маршрута",
    ],
    notIncluded: [
      "Входные билеты в Тадж-Махал и Аграский форт",
      "Обед и напитки",
      "Личные расходы",
      "Чаевые гиду, водителю и фотографу",
    ],
  },
  {
    id: "rishikesh-haridwar",
    title: "Ришикеш и Харидвар: йога, Ганга и Гималаи",
    short: "Уик-энд у истока Ганги — духовное северное направление.",
    duration: "2 дня / 1 ночь",
    price: "от ₽ 24 900 / чел.",
    city: "Ришикеш",
    group: "1–20 чел.",
    image: "https://customer-assets.emergentagent.com/job_seo-tour-guide/artifacts/8jfnwrnd_image.webp",
    highlights: [
      "Ганга-аарти в Хар-Ки-Паури",
      "Мост Лакшман-Джула",
      "Утренняя йога у Ганги",
      "Ашрам Beatles",
    ],
    includes: ["Отель", "Автомобиль из Дели", "Гид Али", "Все входные"],
  },
  {
    id: "agra-fatehpur",
    title: "Агра + Фатехпур-Сикри: две столицы Моголов за день",
    short: "Тадж-Махал и заброшенная имперская столица в одном маршруте.",
    duration: "12 часов",
    price: "от $75 / чел.",
    priceNote: "$150 за 1–2 человек, далее $75 с человека.",
    city: "Агра",
    group: "1–20 чел.",
    image: "https://customer-assets.emergentagent.com/job_seo-tour-guide/artifacts/y23r60fi_original_a4bdb30d-17b3-49f5-a699-88adc0c8ccf2_IMG_20250214_152232047~3.webp",
    description:
      "Тадж-Махал и заброшенная имперская столица Фатехпур-Сикри в одном насыщенном дне. Русскоговорящий гид сопровождает вас лично — от встречи в Агре до возврата. Формат приватный: только вы, ваш темп и живой рассказ о том, почему Акбар построил новую столицу и через 14 лет её оставил.",
    program: [
      { title: "Тадж-Махал и мавзолей Итмад-уд-Даула", desc: "Классический Тадж-Махал в утренние часы + «Малый Тадж» — гробница Итмад-уд-Даулы 1628 года, первый мавзолей из белого мрамора в Индии, прототип великого мавзолея Шах-Джахана." },
      { title: "Форт Агры", desc: "Крепость Акбара из красного песчаника, где жили 4 императора династии Моголов. Балкон Мусамман-Бурдж — то самое место, где Шах-Джахан провёл последние 8 лет жизни в заключении сына Аурангзеба." },
      { title: "Фатехпур-Сикри — «город-призрак»", desc: "Столица империи Акбара, построенная в 1571 и оставленная через 14 лет из-за нехватки воды. Идеально сохранившийся комплекс: дворцы, дворы, гарем, мечеть Джама-Масджид и мавзолей суфия Салима Чишти." },
      { title: "Обед по-моголски", desc: "Обед в ресторане с классической могольской кухней: бирьяни, курица тандури, дал-махани, наан из тандыра, роган-джош, шафрановый рис. Финальный кулфи или гулаб-джамун на десерт." },
    ],
    highlights: [
      "Тадж-Махал и мавзолей Итмад-уд-Даула",
      "Форт Агры",
      "Фатехпур-Сикри — «город-призрак»",
      "Обед по-моголски",
    ],
    includes: [
      "Встреча в отеле Агры и трансфер в отель",
      "Автомобиль с кондиционером",
      "Русскоговорящий гид",
    ],
  },
  {
    id: "taj-friday-yamuna",
    title: "Тадж в пятницу: с другого берега Ямуны",
    short: "Пятничный тур в Агру — Мехтаб-Баг, Малый Тадж, Аграский форт, мастерские и настоящий масала-чай.",
    duration: "10 часов (день)",
    price: "от $75 / чел.",
    priceNote: "$150 за 1–2 человек, далее $75 с человека.",
    city: "Агра",
    group: "1–20 чел.",
    image: "https://cf.youtravel.me/tr:w-1200/public/images/tour/media/2026/06/15/062d48aa20edad847d7bc729e4266987752a2332.jpg",
    externalUrl: "https://youtravel.me/tours/74083/",
    description:
      "Пятничный тур в Агру, когда Тадж-Махал закрыт для входа — и мы смотрим его иначе: с другого берега Ямуны, из сада Мехтаб-Баг, во всей симметрии и без толпы. Плюс Малый Тадж, Аграский форт, живые мастерские и настоящий масала-чай. Русскоговорящий гид Али сопровождает вас лично, формат приватный.",
    program: [
      { title: "Мехтаб-Баг — Тадж-Махал с другого берега Ямуны без толп", desc: "«Лунный сад» — единственная точка, где Тадж-Махал видно во всей симметрии без противоположной толпы. В пятницу, когда мавзолей закрыт, это лучшее место в Агре — тихо, прохладно, идеально для съёмки." },
      { title: "Итмад-уд-Даула (Малый Тадж) — прототип великого мавзолея", desc: "Первый в Индии мавзолей из белого мрамора (1628), заказан Нур-Джахан для отца. Именно здесь впервые применена техника петра-дура — инкрустация полудрагоценными камнями, позже воспроизведённая в Тадж-Махале." },
      { title: "Аграский форт и балкон Шах-Джахана", desc: "Крепость из красного песчаника, построенная Акбаром в 1573. Восьмиугольная башня Мусамман-Бурдж — то самое место, где Шах-Джахан провёл последние 8 лет в заключении, глядя на Тадж-Махал через окно." },
      { title: "Мастерские инкрустации, зардози, ювелиров", desc: "Живые ремесленные мастерские Агры: наблюдаем, как из горного мрамора и полудрагоценных камней создаются шкатулки и столешницы; смотрим золотую вышивку зардози; изучаем звёздчатые рубины и жадеиты." },
      { title: "Финальный масала-чай с кардамоном и имбирём", desc: "Крепкий чёрный чай на молоке с зелёным кардамоном, гвоздикой, имбирём и щепоткой чёрного перца — настоящая индийская чай-масала, как её варят по домам." },
    ],
    highlights: [
      "Мехтаб-Баг — Тадж-Махал с другого берега Ямуны",
      "Итмад-уд-Даула (Малый Тадж)",
      "Аграский форт и балкон Шах-Джахана",
      "Мастерские инкрустации, зардози, ювелиров",
      "Финальный масала-чай",
    ],
    includes: [
      "Встреча в Дели",
      "Русскоговорящий гид",
      "Автомобиль с кондиционером по шоссе Ямуна-экспресс",
      "Завтрак в Агре",
      "Все дорожные расходы и парковки",
      "Возвратный трансфер в Дели",
    ],
  },
  {
    id: "agra-dream-train",
    title: "Поезд мечты Агры: Тадж-Махал на скоростном экспрессе",
    short: "Комфортный день у Тадж-Махала — доезжаем на скоростном поезде Гатиман, никакой усталости от дороги.",
    duration: "1 день (12 часов)",
    price: "$150 / чел.",
    priceNote: "Фиксированная цена $150 с человека — групповой формат.",
    city: "Агра",
    group: "1–20 чел.",
    image: "https://customer-assets.emergentagent.com/job_seo-tour-guide/artifacts/x3agphs6_IMG_20260109_182033795.webp",
    externalUrl: "https://youtravel.me/tours/62279/",
    description:
      "Комфортный день у Тадж-Махала — доезжаем на скоростном поезде «Гатиман» за 90 минут, никакой усталости от дороги. Русскоговорящий гид Али сопровождает вас лично на протяжении всего пути — от вокзала Нью-Дели до возврата вечером. Формат групповой, программа классическая, но темп мягкий: без спешки, с завтраком в вагоне.",
    program: [
      { title: "Скоростной поезд «Гатиман» из Нью-Дели", desc: "Самый быстрый поезд Индии — 160 км/ч. Кресла с откидными спинками, кондиционер, разъёмы для зарядки. Отправление в 8:10 утра, время в пути — 1 час 40 минут." },
      { title: "Завтрак в вагоне второго класса", desc: "Полноценный горячий завтрак включён в билет: индийская классика (масала-омлет, парантха, овощное карри) или континентальная тарелка. Плюс чай масала или кофе, минеральная вода." },
      { title: "Тадж-Махал без спешки (2+ часа)", desc: "Полноценный визит: мавзолей, четыре минарета, сад-чарбаг, зеркальный канал. Отдельный час на прогулку внутри и вокруг, время на фото и рассказ о династии Моголов." },
      { title: "Форт Агры с балконом Шах-Джахана", desc: "Крепость из красного песчаника, мечеть Мина-Масджид, Диван-и-Ам, и восьмиугольная башня Мусамман-Бурдж — окно, из которого Шах-Джахан смотрел на Тадж-Махал последние 8 лет жизни." },
      { title: "Обед по-моголски", desc: "Обед в ресторане с могольской кухней: бирьяни-ягнёнок, курица тандури, дал-махани, наан из тандыра. Возвращение в Дели вечерним поездом «Гатиман»." },
    ],
    organizational: [
      "При себе нужно иметь паспорт или водительское удостоверение",
      "Время в пути из Дели в Агру — 90 минут скоростным поездом",
      "Билеты на поезд вы получите в электронном виде накануне",
      "Начало экскурсии — 6:30 утра встреча в вашем отеле",
      "Поезд может задержаться по независящим от нас причинам — стоимость билетов при отмене не возвращается",
      "Тадж-Махал не работает в пятницу — экскурсия в этот день не проводится",
    ],
    highlights: [
      "Скоростной поезд «Гатиман» из Нью-Дели",
      "Завтрак в вагоне второго класса",
      "Тадж-Махал без спешки (2+ часа)",
      "Форт Агры с балконом Шах-Джахана",
      "Обед по-моголски",
    ],
    includes: [
      "Встреча в отеле Дели",
      "Трансфер на вокзал Дели на комфортабельной машине",
      "Билеты на поезд туда-обратно с питанием",
      "Встреча на вокзале Агры",
      "Комфортабельная машина в Агре с питьевой водой",
      "Все участки дорог, налоги, парковки и бензин",
      "Услуги русскоговорящего гида",
      "Услуги водителя",
      "Трансфер в отель или аэропорт с вокзала Дели",
    ],
    notIncluded: [
      "Входные билеты в монументы — $23 с человека",
      "Личные расходы",
      "Напитки",
      "Благодарность гиду и водителю",
    ],
  },
  {
    id: "airport-to-taj",
    title: "От аэропорта Дели до стен Тадж-Махала и форта Агра",
    short: "Идеально для пересадочного дня: прилетаете утром в Дели — вечером возвращаетесь к рейсу, между этим — Тадж-Махал.",
    duration: "10–11 часов",
    price: "от $90 / чел.",
    priceNote: "$190 за 1–2 человек, далее $90 с человека.",
    city: "Дели · Агра",
    group: "1–20 чел.",
    image: "https://customer-assets.emergentagent.com/job_seo-tour-guide/artifacts/miaypver_IMG_20231111_051342.webp",
    externalUrl: "https://youtravel.me/tours/62263/",
    description:
      "Идеально для пересадочного дня: прилетаете утром в Дели — вечером возвращаетесь к рейсу, между этим — Тадж-Махал. Русскоговорящий гид Али сопровождает вас лично — от встречи в аэропорту до возврата с гирляндой из бархатцев. Формат приватный: ваш темп, ваши интересы и живой рассказ о моголах и живой Индии.",
    program: [
      { title: "Встреча Али в аэропорту Индиры Ганди с гирляндой бархатцев", desc: "Али встречает вас у выхода Arrivals терминала T3 с табличкой на русском и традиционной гирляндой из свежих бархатцев и жасмина. Помощь с багажом, обмен валюты, знакомство и обзор плана дня." },
      { title: "Завтрак в Агре по прибытии", desc: "Комфортный переезд по 6-полосному Ямуна-экспрессу (~2,5 часа), лёгкий завтрак в отеле 4★ с видом на Тадж-Махал через реку — идеальная передышка перед экскурсией." },
      { title: "Тадж-Махал в утренние часы", desc: "Прогулка вокруг мавзолея, когда мрамор ещё сохраняет прохладу ночи и меняет цвет от розового до слепящего белого. Рассказ о Шах-Джахане, Мумтаз-Махал и легендах чёрного мавзолея на другом берегу." },
      { title: "Форт Агры и мавзолей Итмад-уд-Даула", desc: "Крепость Моголов из красного песчаника + «Малый Тадж» — гробница Итмад-уд-Даулы, первый в Индии мавзолей из белого мрамора и прототип Тадж-Махала." },
      { title: "Возврат в аэропорт вовремя к вечернему рейсу", desc: "Али следит за расписанием и оставляет запас 3+ часа до вылета. Довозит до нужного терминала и провожает до стойки регистрации." },
    ],
    highlights: [
      "Встреча в аэропорту с гирляндой бархатцев",
      "Завтрак в Агре по прибытии",
      "Тадж-Махал в утренние часы",
      "Форт Агры и мавзолей Итмад-уд-Даула",
      "Возврат в аэропорт вовремя",
    ],
    includes: [
      "Встреча и провожание в аэропорту",
      "Автомобиль с кондиционером",
      "Русскоговорящий гид",
      "Завтрак в Агре",
      "Питьевая бутылочная вода",
    ],
  },
  {
    id: "living-agra-crafts",
    title: "Тадж-Махал и живая Агра: ювелиры, зардози, чай-масала",
    short: "Тадж без спешки + погружение в живые ремёсла Агры: мастера показывают инкрустацию, вышивку и звёздчатые камни.",
    duration: "12 часов",
    price: "от $75 / чел.",
    priceNote: "$150 за 1–2 человек, далее $75 с человека.",
    city: "Агра",
    group: "1–20 чел.",
    image: "https://customer-assets.emergentagent.com/job_seo-tour-guide/artifacts/qil41bru_IMG_20260127_163141846.webp",
    externalUrl: "https://youtravel.me/tours/38755/",
    description:
      "Тадж-Махал без спешки плюс глубокое погружение в живые ремёсла Агры: мастера показывают инкрустацию мрамора петра-дура, королевскую золотую вышивку зардози и знаменитые звёздчатые камни. Русскоговорящий гид сопровождает вас лично, формат приватный — только вы, ваш темп и разговор с ремесленниками, которые работают, как их предки триста лет назад.",
    program: [
      { title: "Тадж-Махал на рассвете и без спешки", desc: "Вход открывается за 30 минут до восхода. Мрамор меняет цвет от лунно-серого до кораллово-розового за 40 минут. Гуляем по саду-чарбагу, читаем каллиграфию Корана на входных вратах, слушаем историю Мумтаз-Махал." },
      { title: "Мастерская инкрустации мрамора петра-дура", desc: "Техника, которую использовали при постройке самого Тадж-Махала. Наблюдаем, как тончайшие пластинки лазурита, малахита, сердолика и яшмы вырезаются и вдавливаются в мрамор, образуя цветочные узоры. Можно попробовать самому." },
      { title: "Зардози — королевская золотая вышивка", desc: "Ремесло, которое культивировали Моголы для дворцовых одежд. Наблюдаем, как мастер вручную создаёт узоры золотой и серебряной проволокой на бархатной ткани — до 300 часов работы на один килоджей-халат." },
      { title: "Звезда-рубин и чёрный звёздчатый жадеит", desc: "Ювелирная мастерская Агры показывает знаменитые звёздчатые рубины Индии и редкий чёрный звёздчатый жадеит. Мастер объясняет, как рассекается кристалл, чтобы 6-лучевая звезда появилась внутри камня." },
      { title: "Домашний обед в семейном ресторане", desc: "Обед не в туристической точке, а в семейном ресторане, где сама хозяйка готовит могольские блюда: дал-махани, коричневая курица тикка, парантха с фаршем ягнёнка, кулфи с розовой водой." },
      { title: "Настоящий масала-чай на прощание", desc: "Крепкий чёрный чай на молоке с зелёным кардамоном, гвоздикой, свежим имбирём и щепоткой чёрного перца — как варят в семьях Уттар-Прадеш. Отличается от того, что подают в отелях, небом и землёй." },
    ],
    highlights: [
      "Тадж-Махал на рассвете и без спешки",
      "Мастерская инкрустации мрамора петра-дура",
      "Зардози — королевская золотая вышивка",
      "Звезда-рубин и чёрный звёздчатый жадеит",
      "Домашний обед в семейном ресторане",
      "Настоящий масала-чай на прощание",
    ],
    includes: [
      "Встреча в отеле и трансфер в отель Дели",
      "Автомобиль с водителем",
      "Питьевая бутылочная вода в машине",
      "Русскоговорящий гид",
      "Мастер-классы и чай",
    ],
  },
  {
    id: "cooking-class",
    title: "Кулинарный мастер-класс в индийской семье",
    short: "Готовим 5 блюд у настоящей индийской хозяйки — с рецептами домой.",
    duration: "4 часа",
    price: "от ₽ 5 500 / чел.",
    city: "Дели",
    group: "1–20 чел.",
    image: U("1523554888454-84137e72c3ce"),
    highlights: [
      "Дал, карри, роти и десерт",
      "Рынок специй перед готовкой",
      "Совместный ужин с семьёй",
      "Рецепты и специи в подарок",
    ],
    includes: ["Продукты", "Гид Али / переводчик", "Специи в подарок", "Ужин"],
  },
  {
    id: "lotus-akshardham",
    title: "Храмы Дели: Лотос, Акшардхам и Кутб-Минар",
    short: "Архитектурная жемчужина + величайший храмовый комплекс современной Индии.",
    duration: "8 часов",
    price: "от $70 / чел.",
    priceNote: "$150 за 1–2 человек, далее $70 с человека.",
    city: "Дели",
    group: "1–20 чел.",
    image: "https://customer-assets.emergentagent.com/job_seo-tour-guide/artifacts/7hatr5z6_IMG_20191022_160137.webp",
    description:
      "Архитектурная жемчужина Дели и величайший храмовый комплекс современной Индии в одном маршруте. Русскоговорящий гид ведёт вас лично — от встречи в отеле до возврата. Ваш темп, ваши интересы и живой рассказ о духовной архитектуре Индии от XII века до сегодня.",
    program: [
      { title: "Храм Лотоса Бахаи", desc: "Одно из самых фотографируемых зданий мира, освящён в 1986. 27 мраморных лепестков вокруг центрального молитвенного зала. Единственный храм в Дели, открытый одновременно для всех религий." },
      { title: "Акшардхам с водным шоу", desc: "Крупнейший индуистский храмовый комплекс современности (2005). 250 тысяч скульптур из розового песчаника и белого мрамора. Вечернее водно-световое шоу «Сахадж-Ананд» с лазерами и симфоническим саундтреком." },
      { title: "Кутб-Минар — старейший минарет Индии", desc: "73-метровая башня XII века из красного песчаника с исламскими орнаментами и куфической каллиграфией. Первый объект ЮНЕСКО в Индии. Рядом — знаменитая нержавеющая железная колонна IV века." },
    ],
    highlights: [
      "Храм Лотоса Бахаи",
      "Акшардхам с водным шоу",
      "Кутб-Минар — старейший минарет Индии",
    ],
    includes: [
      "Встреча в отеле и трансфер в отель",
      "Автомобиль с кондиционером",
      "Русскоговорящий гид",
      "Входные билеты по программе",
      "Питьевая бутылочная вода в машине",
    ],
  },
  {
    id: "mughal-heritage",
    title: "Наследие Моголов: Хумаюн, Красный форт, Джама-Масджид",
    short: "Три главных памятника династии Великих Моголов в Дели.",
    duration: "6 часов",
    price: "от $55 / чел.",
    priceNote: "$135 за 1–2 человек, далее $55 с человека.",
    city: "Дели",
    group: "1–20 чел.",
    image: "https://customer-assets.emergentagent.com/job_seo-tour-guide/artifacts/1bc2kttn_IMG_20191022_135423~2.webp",
    description:
      "Три главных памятника династии Великих Моголов в Дели за один маршрут. Русскоговорящий гид сопровождает вас лично — от встречи в отеле до возврата. Никаких групп из автобуса, только ваш темп, ваши интересы и живой рассказ о династии, изменившей Индию на 300 лет.",
    program: [
      { title: "Гробница Хумаюна — прообраз Тадж-Махала", desc: "Мавзолей построен в 1570 году вдовой императора Хумаюна и стал первой могольской гробницей-мавзолеем в форме сада-чарбаг. Вдохновил Шах-Джахана на создание Тадж-Махала спустя 80 лет. Объект ЮНЕСКО." },
      { title: "Красный форт Дели", desc: "Грандиозная крепость из красного песчаника, построенная Шах-Джаханом в 1648 году как новая столица империи. Дворец Диван-и-Ам, покои Мумтаз, восьмиугольная башня и Жемчужная мечеть." },
      { title: "Мечеть Джама-Масджид", desc: "Крупнейшая мечеть Индии, вмещает 25 000 молящихся. Три белых мраморных купола, два минарета 41 м. Хранит реликвию — волос из бороды пророка Мухаммеда и оригинал Корана, написанный на оленьей коже." },
      { title: "Чандни-Чоук пешком", desc: "«Лунная площадь» — главная торговая улица могольской эпохи, спроектированная дочерью Шах-Джахана Джаханарой. От серебряных лавок до знаменитой Параthа-гали и Джалеби-вала XIX века." },
    ],
    highlights: [
      "Гробница Хумаюна — прообраз Тадж-Махала",
      "Красный форт Дели",
      "Мечеть Джама-Масджид",
      "Чандни-Чоук пешком",
    ],
    includes: [
      "Автомобиль с кондиционером",
      "Встреча в отеле и трансфер в отель",
      "Русскоговорящий гид",
      "Все входные билеты по программе",
      "Бутылочная вода в машине",
    ],
  },
  {
    id: "sikh-temples",
    title: "Босоногий Дели: сикхи, Бангла-Сахиб и общая кухня",
    short: "Гурудвара, где кормят 30 000 человек в день — глубокий духовный опыт.",
    duration: "3 часа",
    price: "от $45 / чел.",
    priceNote: "$100 за 1–2 человек, далее $45 с человека.",
    city: "Дели",
    group: "1–20 чел.",
    image: "https://customer-assets.emergentagent.com/job_seo-tour-guide/artifacts/kaca6t9w_IMG_20170907_175647.webp",
    description:
      "Гурудвара Бангла-Сахиб, где кормят 30 000 человек в день — глубокий духовный опыт с сикхской философией равенства. Русскоговорящий гид сопровождает вас лично — от встречи в отеле до возврата. Программа расширена: включаем колодец Аграсен, храм Лакшми-Нараяна, Ворота Индии и Дом президента.",
    program: [
      { title: "Гурудвара Бангла-Сахиб", desc: "Сикхский храм с золотым куполом на месте, где остановился 8-й гуру Хар Кришан. Священный «сарова» — пруд, вода которого, по преданию, исцеляет. Обязательное покрытие головы, обувь оставляем при входе." },
      { title: "Кухня Лангар", desc: "Общая бесплатная кухня, кормит до 40 000 паломников в день. Все едят на полу, независимо от касты, вероисповедания и достатка — краеугольный принцип равенства сикхизма, действующий с XV века." },
      { title: "История сикхизма от гида", desc: "Краткий рассказ о десяти гуру, о принципе равенства и о том, почему сикхи носят тюрбан, не стригут волосы и носят кару-браслет. 5% населения Индии, но лидеры армии и бизнеса." },
      { title: "Ступенчатый колодец Аграсен-Ки-Баоли", desc: "60-метровый колодец XIV века с 108 ступенями. Место съёмок «PK» с Аамиром Кханом. Легенда: построен царём Аграсеном для города, а по ночам здесь появляются духи предков." },
      { title: "Храм Лакшми-Нараяна (Бирла-Мандир)", desc: "Храм Вишну и его супруги Лакшми в стиле «нагара», построен семьёй Бирла в 1939 году. Открывал храм лично Махатма Ганди — при одном условии: чтобы двери были открыты для всех каст." },
      { title: "Ворота Индии", desc: "«Триумфальная арка» 42 м в память о 90 000 индийских солдат, погибших в Первой мировой войне и Третьей англо-афганской. Вечный огонь Amar Jawan Jyoti горит с 1971 года." },
      { title: "Дом президента", desc: "Резиденция президента Индии — Раштрапати Бхаван. 340 комнат, крупнейшая президентская резиденция в мире. Строил её британский архитектор Эдвин Лаченс в 1929 году." },
    ],
    highlights: [
      "Гурудвара Бангла-Сахиб",
      "Кухня Лангар",
      "История сикхизма от гида",
      "Ступенчатый колодец Аграсен-Ки-Баоли",
      "Храм Лакшми-Нараяна",
      "Ворота Индии",
      "Дом президента",
    ],
    includes: [
      "Встреча в отеле и трансфер в отель",
      "Машина с кондиционером",
      "Русскоговорящий гид",
      "Платок / покрытие головы",
      "Обед-лангар (по желанию)",
    ],
  },
  {
    id: "akshardham-fountain-show",
    title: "Шоу фонтанов в храме Акшардхам",
    short: "Вечернее водно-световое шоу «Сахадж-Ананд» в крупнейшем индуистском комплексе мира.",
    duration: "4 часа",
    price: "от $45 / чел.",
    priceNote: "$100 за 1–2 человек, далее $45 с человека.",
    city: "Дели",
    group: "1–20 чел.",
    image: "https://customer-assets.emergentagent.com/job_seo-tour-guide/artifacts/oql7ez0l_IMG-20230209-WA0028.jpg",
    description:
      "Вечернее водно-световое шоу «Сахадж-Ананд» в крупнейшем индуистском храмовом комплексе мира. Русскоговорящий гид Али сопровождает вас лично — от встречи в отеле до возврата. Формат приватный: ваш темп, ваши интересы и живой рассказ о духовной архитектуре современной Индии.",
    program: [
      { title: "Осмотр храма Сваминараян Акшардхам", desc: "Крупнейший индуистский храмовый комплекс мира, попал в Книгу рекордов Гиннесса. Открыт в 2005 году, полностью построен без стального каркаса — только резной песчаник и мрамор по принципам древних шастр." },
      { title: "Резной розовый песчаник и мраморные фигуры", desc: "20 000 фигур богов, святых и учителей. Ни одна не повторяется. Каждая деталь высечена вручную 11 000 ремесленниками из Раджастана за 5 лет работы." },
      { title: "Вечернее шоу фонтанов «Сахадж-Ананд»", desc: "15-минутное представление света, воды, лазеров и симфонической музыки о жизни Свами Нараяна. Считается одним из лучших водно-световых шоу Азии. Смотреть под открытым небом." },
      { title: "Ужин в вегетарианской «деревне» Ясной (по желанию)", desc: "Попробовать 15+ традиционных блюд Индии в стилизованной раджастанской деревне на территории храма. Только чистая вегетарианская кухня, без лука и чеснока, по принципам сатвической диеты." },
    ],
    highlights: [
      "Осмотр храма Сваминараян Акшардхам",
      "Резной розовый песчаник и мраморные фигуры",
      "Вечернее шоу фонтанов «Сахадж-Ананд»",
      "Ужин в вегетарианской «деревне» Ясной",
    ],
    includes: [
      "Встреча в отеле и трансфер в отель",
      "Автомобиль с кондиционером",
      "Русскоговорящий гид",
      "Входные билеты",
      "Билет на шоу фонтанов",
    ],
  },
  {
    id: "delhi-transit",
    title: "Дели за 7 часов: транзитный тур из аэропорта",
    short: "Свободный день между рейсами — превратим его в впечатление жизни.",
    duration: "8 часов",
    price: "от $60 / чел.",
    priceNote: "$135 за 1–2 человек, далее $60 с человека.",
    city: "Дели",
    group: "1–20 чел.",
    image: "https://customer-assets.emergentagent.com/job_seo-tour-guide/artifacts/5eamyyuk_IMG_20241226_063524061.webp",
    description:
      "Свободный день между рейсами — превратим его в впечатление жизни. Русскоговорящий гид Али встречает вас в аэропорту Индиры Ганди с гирляндой из бархатцев, показывает топ-5 достопримечательностей Дели, кормит настоящей индийской едой и возвращает к рейсу вовремя.",
    program: [
      { title: "Встреча в аэропорту", desc: "Али встречает у выхода Arrivals в T3 с гирляндой из бархатцев и табличкой на русском. Помощь с багажом и обменом валюты, знакомство и обзор плана дня." },
      { title: "Топ-5 достопримечательностей Дели", desc: "Ворота Индии, Дом президента (Раштрапати Бхаван), Храм Лакшми-Нараяна, Гурудвара Бангла-Сахиб и Старый Дели — концентрированный tour de force столицы за 5–6 часов." },
      { title: "Обед в аутентичном месте", desc: "Обед в проверенном ресторане индийской кухни: тхали (комплексный поднос из 8 блюд) или на выбор — курица тандури, дал-махани, бирьяни, паneer тикка. Всё безопасно для непривычного желудка." },
      { title: "Возврат в аэропорт вовремя", desc: "Али следит за расписанием рейса и оставляет запас 3+ часа до вылета. Довозит до нужного терминала и провожает до стойки регистрации." },
    ],
    highlights: [
      "Встреча в аэропорту",
      "Топ-5 достопримечательностей Дели",
      "Обед в аутентичном месте",
      "Возврат в аэропорт вовремя",
    ],
    includes: [
      "Встреча в аэропорту и трансфер в аэропорт",
      "Автомобиль с кондиционером",
      "Русскоговорящий гид",
      "Бутылочная вода в машине",
    ],
  },
  {
    id: "goa-heritage",
    title: "Гоа-хайлайты: обзорная по северному Гоа",
    short: "Панджи, Старый Гоа, форт и пляж Калангут за один день.",
    duration: "8 часов",
    price: "от $65 / чел.",
    priceNote: "$130 за 1–2 человек, далее $65 с человека.",
    city: "Гоа",
    group: "1–20 чел.",
    image: "https://customer-assets.emergentagent.com/job_seo-tour-guide/artifacts/c16z43of_IMG_20260705_135344521~2.webp",
    description:
      "Обзорная экскурсия по северному Гоа с русскоговорящим гидом Али: португальская столица Панджи, Старый Гоа и его базилики, старинный форт Агуада и лучший пляж региона Калангут. Формат приватный, темп мягкий — только вы, ваша компания и живой рассказ о 450 годах португальского наследия в тропической Индии.",
    program: [
      { title: "Панджи (Панаджим) — столица штата", desc: "Крохотный колониальный центр Гоа с бело-жёлтыми португальскими особняками, узкими улочками латинского квартала Фонтаинхас и церковью Богоматери Непорочного зачатия." },
      { title: "Старый Гоа и Базилика Бом-Жезус", desc: "Первая столица Португальской Индии — сегодня объект ЮНЕСКО. Базилика Бом-Жезус хранит нетленные мощи святого Франциска Ксаверия. Собор Св. Екатерины — крупнейшая церковь Азии XVI века." },
      { title: "Форт Агуада с маяком", desc: "Португальская крепость XVII века над Аравийским морем — защищала Гоа от голландцев и маратхов. Действующий маяк, панорама океана и пляжа Синкерим." },
      { title: "Пляж Калангут", desc: "Главный пляж северного Гоа: 7 км золотого песка, тёплое Аравийское море, шаки с морепродуктами и живой музыкой. Обед на пляже, свежий улов и охлаждённое пиво «Кингфишер»." },
    ],
    highlights: [
      "Панджи — столица штата",
      "Старый Гоа и Базилика Бом-Жезус",
      "Форт Агуада с маяком",
      "Пляж Калангут",
    ],
    includes: [
      "Автомобиль с кондиционером",
      "Русскоговорящий гид",
      "Все входные билеты",
      "Питьевая бутылочная вода",
    ],
  },
  {
    id: "udaipur",
    title: "Удайпур: озёрный город раджей",
    short: "«Венеция Востока» — белые дворцы и закаты на воде.",
    duration: "2 дня / 1 ночь",
    price: "от ₽ 27 900 / чел.",
    city: "Удайпур",
    group: "1–20 чел.",
    image: U("1496372412473-e8548ffd82bc"),
    highlights: [
      "Городской дворец на озере Пичола",
      "Лодка вокруг Джаг-Мандир",
      "Сад Саэлион-Ки-Бари",
      "Шоу традиционных танцев",
    ],
    includes: ["Отель с видом", "Перелёт/поезд", "Гид Али", "Лодка"],
  },
  {
    id: "jodhpur",
    title: "Синий Джодхпур: крепость Мехрангарх",
    short: "Синий город Раджастана и одна из величайших крепостей Индии.",
    duration: "2 дня / 1 ночь",
    price: "от ₽ 26 900 / чел.",
    city: "Джодхпур",
    group: "1–20 чел.",
    image: "https://customer-assets.emergentagent.com/job_seo-tour-guide/artifacts/fo4pptl9_IMG_20181123_175406.webp",
    highlights: [
      "Форт Мехрангарх на закате",
      "Синие улицы старого города",
      "Часовая башня и рынки",
      "Раджастанский ужин",
    ],
    includes: ["Хавели-отель", "Автомобиль/поезд", "Гид Али", "Все входные"],
  },
  {
    id: "custom-tour",
    title: "Индивидуальный маршрут: составим под вас",
    short: "Скажите, что хотите увидеть — соберу маршрут за 24 часа.",
    duration: "по запросу",
    price: "от ₽ 4 900 / чел.",
    city: "Вся Индия",
    group: "1–20 чел.",
    image: U("1523805009345-7448845a9e53"),
    highlights: [
      "Личный менеджер маршрута",
      "Проверенные отели и водители",
      "Русскоговорящий гид Али",
      "Поддержка 24/7 в поездке",
    ],
    includes: ["По согласованию", "Индивидуальный подход", "Гид Али", "Круглосуточная связь"],
  },
];

// Групповые туры с фиксированными датами (ежегодные фестивали + еженедельный «Индия для искателей»)
export const GROUP_TOURS = [
  {
    id: "diwali-8day-2026",
    title: "Дивали в Индии: 8 дней огней, света и древних традиций",
    short:
      "Проживите три главных дня Дивали как настоящие индийцы — Дели, Джайпур, Агра, Кхаджурахо, Варанаси.",
    duration: "8 дней / 7 ночей",
    dates: "06 – 13 ноября 2026",
    frequency: "annual",
    price: "от $850 / чел.",
    priceNote: "Скидка -5% при ранней брони. Гарантированный заезд.",
    city: "Дели · Джайпур · Агра · Кхаджурахо · Варанаси",
    group: "1–20 чел.",
    image: "https://cf.youtravel.me/tr:w-1200/public/images/tour/media/2025/07/14/dc7021ed65355f53d27a75db91673099cbf0a4c5.jpg",
    externalUrl: "https://youtravel.me/tours/63449/",
    description:
      "8 дней магии, света и древних традиций с русскоговорящим гидом. Мы отмечаем ТРИ главных дня Дивали: 06 ноября — Дхантерас (день богатства), 07 ноября — Чхоти Дивали (ночь огней и семейных традиций), 08 ноября — Главный Дивали (грандиозный фестиваль света). Это единственный тур, где вы проживёте Дивали как настоящие индийцы — с ритуалами, фейерверками, подарками, священными огнями и пуджей Лакшми.",
    longDescription: [
      "### Почему это путешествие особое",
      "Ваш гид — не просто экскурсовод, а хранитель традиций: он откроет тайные обряды и проведёт туда, где празднуют местные. Маршрут проходит сквозь время — от шумных базаров Дели до мистических гхатов Варанаси, где Дивали встречают с особым благоговением.",
      "### Атмосфера огней, запахов, звуков",
      "Базары, переполненные сладостями и украшениями. Ароматы гульаб-джамун, барфи и масала-чая. Гул фейерверков, звон колокольчиков, мантры. Это не просто путешествие — это инициация в мир настоящей Индии. Вы увезёте: опыт, который меняет взгляд на мир; фотографии, от которых друзья прийдут в восторг; благословение Лакшми на год удачи и процветания.",
    ],
    program: [
      { title: "День 1 · Дхантерас: встреча в Дели с гирляндой из цветов", desc: "Трансфер из аэропорта, размещение в отеле. Экскурсия по Новому Дели: Храм Лотоса, Ворота Индии, Дом Президента, Храм Бирла Мандир, ступенчатый колодец Аграсен Ки Баоли, легендарная прачечная Дели. Традиционный индийский комплексный обед. Ночь в Дели." },
      { title: "День 2 · Чхоти Дивали: величие и хаос старого Дели → Джайпур", desc: "Утром — храм Акшардхам из розового камня. Затем контраст: Старый Дели, Чандни-Чоук, велорикша по Кинари Базару и Дарья Ганжу. Обед в дороге. Переезд в Джайпур." },
      { title: "День 3 · Главный Дивали в Розовом городе Джайпуре", desc: "Форт Амбер на джипах, Зеркальный зал Шиш-Махал. Дворец на воде Джал Махал, Хава Махал, Городской дворец, обсерватория Джантар-Мантар. Раджастханский обед. По желанию: деревня слонов. Вечером — тысячи огней, фейерверки, ранголи, встреча с придворным астрологом." },
      { title: "День 4 · Из Джайпура в Агру через сокровища Раджастана", desc: "Абханери и ступенчатый колодец Чанд Баори IX века (3500 ступеней). Фатехпур Сикри — забытая столица Акбара: Буланд Дарваза, Джама Масджид, Диван-и-Ам, Панч Махал. Обед по пути. Прибытие в Агру." },
      { title: "День 5 · Сокровища Агры: сари, драгоценности и любовь", desc: "Салон сари. Тадж-Махал — символ вечной любви. Завтрак в отеле. Аграский форт. Эксклюзивные мастерские: ювелирная (трон Павлина, могольские камни), инкрустация пиетра-дура, пашмина и зардози, масала-чай и специи. Вечером — спектакль «Мохаббат-э-Тадж»." },
      { title: "День 6 · Кхаджурахо: где боги танцуют в камне", desc: "Скоростной поезд Ванде Бхарат из Агры (7:45), завтрак и обед в вагоне, прибытие 14:20. Размещение. Храмы Кхаджурахо (ЮНЕСКО) с эротическими скульптурами династии Чандела. Ужин на крыше с видом на храмы." },
      { title: "День 7 · Варанаси: священный Ганг", desc: "Переезд в Варанаси. Экскурсия по старому городу на тук-туке: храм Каши Вишванатх, гхаты, Маникарника Гхат. Закатная лодочная прогулка и Ганга Аарти на Дашвамедх Гхате — огни, мантры, тысячи светильников на воде." },
      { title: "День 8 · Возвращение в Дели", desc: "Утренняя рассветная лодка (по желанию). Скоростной поезд в Дели с обедом в вагоне. Трансфер в аэропорт." },
    ],
    highlights: [
      "Дхантерас, Чхоти Дивали и Главный Дивали — три священных дня",
      "Форт Амбер на джипах и Розовый Джайпур",
      "Тадж-Махал + фотосессия в сари",
      "Кхаджурахо — храмы Камасутры",
      "Варанаси: рассветная лодка и вечерняя Ганга-аарти",
      "Мастер-классы: диии, ранголи, встреча с астрологом",
    ],
    includes: [
      "Встреча в аэропорту Дели с гирляндой из цветов",
      "Проживание в отелях 3–4★ (2-местное размещение) с завтраками",
      "Русскоговорящий гид Али на весь маршрут",
      "Мини-автобус с кондиционером и бутылочной водой",
      "Билеты скоростного поезда Ванде Бхарат с питанием",
      "Все входные билеты в монументы",
      "Комплексные традиционные обеды и ужины по программе",
      "Катание на джипах в форт Амбер",
      "Катание на велорикше в Старом Дели, тук-туке в Варанаси",
      "Лодка в Варанаси",
      "Все переезды из города в город, налоги, парковки, бензин",
      "Трансфер в аэропорт по окончании тура",
    ],
    notIncluded: [
      "Авиабилеты Москва–Дели–Москва (от $400)",
      "Виза (помощь с оформлением бесплатно)",
      "Спектакль «Мохаббат-э-Тадж» ($55 с чел.)",
      "Сафари в Кхаджурахо ($85 с чел., минимум 4 участника)",
      "Личные расходы и напитки",
      "Доплата за одноместное размещение ($300)",
      "Чаевые гиду и водителю",
    ],
    organizational: [
      "Оплата отелей и ж/д билетов — рублями на карту Сбербанка за 25 дней до старта",
      "Тадж-Махал закрыт по пятницам",
      "Многие храмы Дели закрыты по понедельникам",
      "Дресс-код в храмах: закрытые плечи и колени",
      "Хранение вещей в храмах — от 100 ₽ с человека",
      "Возможны задержки поездов по независящим от нас причинам",
      "Предоплата невозвратна при отмене со стороны туриста",
    ],
  },
  {
    id: "ny-delhi-varanasi",
    title: "Волшебный Новый год в Индии: от Дели до Варанаси с гала-ужином",
    short:
      "7 дней праздника, величия и традиций. Встречаем Новый год в Агре с роскошным гала-ужином под фейерверки и живую музыку.",
    duration: "7 дней / 6 ночей",
    dates: "28 декабря 2026 – 03 января 2027",
    frequency: "annual",
    price: "от $1 120 / чел.",
    priceNote: "Скидка -5% при ранней брони. Ежегодный тур, доступны заезды 2027–2031.",
    city: "Дели · Джайпур · Агра · Кхаджурахо · Варанаси",
    group: "1–20 чел.",
    image: "https://customer-assets.emergentagent.com/job_seo-tour-guide/artifacts/wsvs2e9k_IMG_20250101_000337112.webp",
    externalUrl: "https://youtravel.me/tours/63489/",
    description:
      "Единственный тур, где вы встретите Новый год в Агре — с шампанским, фейерверками и изысканным ужином в лучших традициях эпохи Великих Моголов. Ваш гид — знаток истории, который покажет скрытые уголки Индии и раскроет секреты древних традиций. Маршрут сквозь века — от шумных улиц Дели до завораживающего Тадж-Махала, от дворцов Джайпура до мистических гхатов Варанаси.",
    longDescription: [
      "### Что делает этот тур особенным",
      "Гала-ужин в Агре с шампанским, изысканной кухней Великих Моголов, живой музыкой и фейерверками в окружении одного из чудес света. Рассвет у Тадж-Махала — первое утро года, озаренное розовыми лучами солнца на белом мраморе. Мистика Варанаси — вечерняя церемония Ганга Аарти с огнями и мантрами.",
      "### Погружение в Индию",
      "Роскошь Великих Моголов, сокровища Раджастхана (подъём на слонах к форту Амбер, зеркальные залы), храмы Кхаджурахо, контрасты Дели, мастер-классы, дегустации, шопинг специй и чая.",
    ],
    program: [
      { title: "День 1 · 28 декабря — встреча в Дели", desc: "Прибытие в аэропорт, гирлянды из цветов, трансфер в отель. Раннее размещение (3★). Экскурсия по Новому Дели: Храм Лотоса, Ворота Индии, Дом Президента, Аграсен Ки Баоли. Обед. Вечерний шопинг: новогодние украшения, специи, чай." },
      { title: "День 2 · Контрасты столицы → переезд в Джайпур", desc: "Акшардхам — грандиозный храмовый комплекс. Старый Дели: велорикша по Чандни-Чоук, Джама-Масджид. Переезд в Джайпур (4 часа). Вечерний ужин под звёздами с фолк-музыкой Раджастана: калбелия, гхумар, живые выступления." },
      { title: "День 3 · Джайпур: Розовый город и форт Амбер", desc: "Форт Амбер — подъём на слонах, зеркальный зал, виды на озеро. Джал-Махал, Хава-Махал, Городской дворец, Джантар-Мантар. Мастер-класс по окраске текстиля и производству ручных ковриков. Переезд в Агру (4 часа)." },
      { title: "День 4 · Новогодний Гала-ужин в Агре", desc: "Раннее утро у Тадж-Махала — встреча первого рассвета года. Агра-форт — резиденция Великих Моголов. Эксклюзивные мастерские: ювелирная (Павлиний трон), инкрустация пиетра-дура, пашмина и зардози, чай и специи. Обед. Вечерний спектакль «Мохаббат-э-Тадж». Гала-ужин в отеле с изысканной кухней, живой музыкой и фейерверком в полночь!" },
      { title: "День 5 · Кхаджурахо: храмы Камасутры", desc: "Скоростной поезд из Агры в 7:45 (завтрак и обед в поезде), прибытие 14:00. Экскурсия по храмовому комплексу ЮНЕСКО с эротическими скульптурами. Ужин на крыше с видом на древние храмы." },
      { title: "День 6 · Варанаси: священный Ганг", desc: "Переезд в 7:00, прибытие 14:00. Обед в отеле. Экскурсия на рикшах в старый город: гхаты, храмы, кремационные гхаты (Маникарника, Харишчандра). Ганга Аарти — огни, мантры, лодочная прогулка. Экскурсия на шёлковую фабрику: банараси-шёлк, зари, ткачество на старинных станках." },
      { title: "День 7 · Дорога домой из Варанаси в Дели", desc: "Выселение в 11:00. Трансфер на вокзал. Скоростной поезд Варанаси–Дели в 15:00 (ужин в поезде). Прибытие в 23:00. Трансфер с вокзала в аэропорт. Завершение тура." },
    ],
    highlights: [
      "Гала-ужин в Агре с фейерверком в полночь",
      "Рассвет у Тадж-Махала 1 января",
      "Ганга Аарти в Варанаси",
      "Подъём на слонах к форту Амбер",
      "Храмы Кхаджурахо",
      "Мастерские Агры: ювелиры, пиетра-дура, зардози",
    ],
    includes: [
      "Проживание в отелях 3–4★ + раннее размещение в Дели",
      "Все завтраки + Гала-ужин в Агре",
      "Комплексный ужин в Джайпуре и на крыше в Кхаджурахо",
      "Комплексный обед в Агре",
      "Прогулка на слоне в Джайпуре",
      "Прогулка на велорикше в Старом Дели",
      "Русскоговорящий гид Али",
      "Все входные билеты по программе",
      "Билеты скоростного поезда с питанием",
      "Помощь в оформлении электронной визы",
      "Все трансферы и переезды",
    ],
    notIncluded: [
      "Авиабилеты Москва–Дели–Москва (от $400)",
      "Спектакль в Агре ($55 с чел.)",
      "Деревня слонов в Джайпуре (от $50)",
      "Визит к астрологу в Джайпуре (от $20)",
      "Личные расходы и дополнительные экскурсии",
      "Доплата за одноместное размещение ($300)",
      "Чаевые гиду",
    ],
    organizational: [
      "Оплата отелей и билетов на поезд — 25% в рублях на карту Сбербанка",
      "Тадж-Махал закрыт по пятницам (доступен прокат сари)",
      "Многие храмы Дели закрыты по понедельникам, дресс-код обязателен",
      "Хранение вещей — от 50 ₽ с человека",
      "Сафари в Кхаджурахо по желанию: $85 с чел., от 4 участников",
      "Возможны задержки поездов по независящим причинам",
      "Организатор вправе вносить изменения при непредвиденных обстоятельствах",
    ],
  },
  {
    id: "diwali-golden-triangle-4d",
    title: "Дивали: 4 дня сияющего Золотого треугольника",
    short:
      "Экспресс-Дивали для тех, у кого мало времени. Дели, Джайпур, Агра в дни главного праздника Индии — фейерверки, тысячи огней, королевский ужин.",
    duration: "4 дня / 3 ночи",
    dates: "08 – 11 ноября 2026",
    frequency: "annual",
    price: "от $710 / чел.",
    priceNote: "Осталось 10 мест.",
    city: "Дели · Джайпур · Агра",
    group: "1–20 чел.",
    image: "https://customer-assets.emergentagent.com/job_seo-tour-guide/artifacts/2euz6m1a_IMG_20251020_192237950.webp",
    externalUrl: "https://youtravel.me/tours/39785/",
    description:
      "Представьте: ноябрь, Индия, 5 дней непрерывного волшебства Дивали — главного праздника страны. Особое очарование — в третий день, когда повсюду вспыхивают огни. Индусы украшают цветами дома, расставляют мерцающие лампадки-дия и свечи, в небе взрываются фейерверки. Светлый ритуал призван привлечь богиню Лакшми — покровительницу богатства.",
    longDescription: [
      "### Что вы увезёте с собой",
      "Ошеломляющий фейерверк, который длится не минуту, а всю ночь. Тысячи живых огоньков у ваших ног — глиняные дия и свечи у каждого порога. Ароматный хаос цветочных рынков: жасмин, бархатцы, розы, благовония, сладости. Радость божественной охоты за Лакшми — чем ярче горит твой дом, тем больше шансов, что богиня заглянет.",
      "### Больше чем праздник",
      "Индия без сна и без границ — пять дней город гудит, смеётся, танцует и не гаснет. Сладкая бомба вкуса — ладу и джалеби под вспышками фейерверка. Фото, которые невозможно повторить: золотой дым, отражения огней в глазах прохожих. Дивали празднуют уже тысячи лет — вы прикасаетесь к вечному.",
    ],
    program: [
      { title: "День 1 · Дели — город двух миров", desc: "Прибытие в Дели, гирлянда из цветов, размещение в отеле. Экскурсия по Новому Дели: Храм Бирла Мандир (Лакшми Нараян), Храм Лотоса, Акшардхам (крупнейший индуистский храм мира), Аграсен Ки Баоли, Сад Лодхи, Ворота Индии, Дом Президента. Традиционный комплексный обед. Ночь в Дели." },
      { title: "День 2 · Тайны Старого Дели + Королевское Дивали в Джайпуре", desc: "Экскурсия по Старому Дели: Мечеть Джами, Чандни-Чоук с велорикшей, Красный Форт, Гурудвара Сис Гандж Сахиб. Переезд в Джайпур (4 часа). Обед по дороге. По желанию: визит к астрологу. Главное событие — Дивали с королевской семьёй в одном из их дворцов с ужином, огнями, фейерверками и мантрами." },
      { title: "День 3 · Ритм Розового города", desc: "Форт Амбер — подъём на слоне, как раньше делали махараджи. Джал-Махал (Водный дворец), Хава-Махал (Дворец ветра), Джантар-Мантар (обсерватория XVIII века), Городской дворец. Обед. Храм обезьян Галта в горном ущелье. Переезд в Агру (4 часа)." },
      { title: "День 4 · Во имя любви — Агра", desc: "Тадж-Махал — легенды и реальные факты от гида. Аграский форт: дворец Джахангира, спальня Шах-Джахана и Мумтаз, Муссамман-Бурдж, Зеркальный дворец, Трон из чёрного оникса. Индийский обед. Бэби Тадж (Итимад-уд-Даула). Лунный сад Мехтаб-Баг — Тадж с другой стороны Ямуны. Возвращение в Дели (3 часа), трансфер в аэропорт." },
    ],
    highlights: [
      "Дивали с королевской семьёй в дворце Джайпура",
      "Тадж-Махал и Лунный сад Мехтаб-Баг",
      "Форт Амбер с подъёмом на слоне",
      "Акшардхам и Храм Лотоса",
      "Красный Форт и велорикша в Старом Дели",
      "Индивидуальное предсказание астролога (по желанию)",
    ],
    includes: [
      "Встреча в аэропорту Дели с гирляндой из цветов",
      "Проживание в отелях 3–4★ с завтраками (2-местное размещение)",
      "4 традиционных комплексных обеда",
      "1 традиционный комплексный ужин (Дивали с королевской семьёй)",
      "Все входные билеты в монументы",
      "Прогулка на слоне в форте Амбер",
      "Комфортабельный автомобиль с кондиционером и бутылочной водой",
      "Все переезды: Дели–Джайпур–Агра–Дели",
      "Русскоговорящий гид Али",
      "Услуги водителя, все дорожные сборы, налоги, парковки, бензин",
      "Трансфер в аэропорт по окончании тура",
    ],
    notIncluded: [
      "Авиабилеты",
      "Напитки",
      "Личные расходы",
      "Любая дополнительная программа",
      "Визит к астрологу в Джайпуре (по желанию)",
    ],
    organizational: [
      "Оплата отелей — рублями на карту Сбербанка за 25 дней до старта (невозвратно при отмене)",
      "Тадж-Махал закрыт по пятницам (доступен прокат сари)",
      "Многие храмы Дели закрыты по понедельникам",
      "Дресс-код: закрытые плечи и колени, без шорт",
      "Хранение вещей — от 50 ₽ с человека",
      "Электронная виза оформляется бесплатно на indianvisaonline.gov.in/evisa/",
    ],
  },
  {
    id: "holi-festival",
    title: "Тур-фестиваль красок: Волшебство Холи в Индии",
    short:
      "8 дней взрыва красок, музыки и радости. Празднуем главный весенний фестиваль Индии в Агре с настоящими индийскими семьями.",
    duration: "8 дней / 7 ночей",
    dates: "19 – 26 марта 2027",
    frequency: "annual",
    price: "от $860 / чел.",
    priceNote: "Скидка -5% при ранней брони. Осталось 20 мест.",
    city: "Дели · Джайпур · Агра · Варанаси · Кхаджурахо",
    group: "1–20 чел.",
    image: "https://customer-assets.emergentagent.com/job_seo-tour-guide/artifacts/yhk19axn_IMG-20230309-WA0030.jpg",
    externalUrl: "https://youtravel.me/tours/59365/",
    description:
      "Праздник Холи — торжество добра над злом, победа света над тьмой. По легенде, злая Холика хотела погубить преданного Вишну Прахлада в огне, но чудо спасло мальчика, а Холика сгорела. С тех пор Холи — символ торжества веры и справедливости. Главная традиция — буйство красок: люди обливают друг друга подкрашенной водой, осыпают ароматными порошками, танцуют. Улицы превращаются в радугу.",
    longDescription: [
      "### В этом туре вас ждёт",
      "Участие в настоящем Холи в Агре с музыкой, танцами и обсыпанием красками. Эксклюзивные мастер-классы: натуральные краски и традиционные сладости. Встреча с местными семьями, которые покажут, как отмечают Холи в домашнем кругу. Фотосессия в ярких нарядах.",
      "### Почему именно этот тур",
      "Холи в Индии — это не туристическое шоу, а настоящий народный праздник. Безопасность: мы знаем, где играть красками. Ваш гид родом из Агры — его любовь к стране и глубокие знания превратят каждый день в увлекательное погружение в настоящую Индию. За пределами туристических троп: местные кварталы, школы, рынки.",
    ],
    program: [
      { title: "День 1 · Контрасты Дели — гирлянды, рикши и шёпот веков", desc: "Встреча в аэропорту с гирляндой из цветов, трансфер в отель. В 10:00 — старт экскурсии. Новый Дели: Раджпатх и Джанпатх, Храм Бирла Мандир, Храм Лотоса, Акшардхам, Аграсен Ки Баоли, Ворота Индии, Раштрапати-Бхаван. Обед. Старый Дели: Джами Масджид, велорикша по Чандни-Чоук, Красный Форт." },
      { title: "День 2 · Переезд из Дели в Джайпур", desc: "Выезд в 9:00 после завтрака, 4 часа в пути. Прибытие в Джайпур, размещение. Визит к астрологу (ведическая астрология, гороскоп). Джайпурская миниатюра. Магия окрашивания тканей натуральными красителями. Традиционный ужин под открытым небом с народной музыкой и танцами Раджастана." },
      { title: "День 3 · День приключений — форты Джайпура → Агра", desc: "Утро: поездка на внедорожнике к форту Амбер (XVI век). Джал-Махал (Дворец на воде), Хава-Махал (Дворец Ветров), Городской дворец, Джантар-Мантар. Традиционный раджастханский обед. Переезд в Агру (4 часа)." },
      { title: "День 4 · День Великих Моголов — Сокровища Агры на Холи!", desc: "Экскурсия совпадёт с праздником Холи — магический день! Облачение в традиционные белые одежды. Тадж-Махал — шедевр в мраморе. Холи у стен Аграского форта: обсыпание гуралом, обливание водой, танцы под дхолак, тхандай. Аграский форт — цитадель власти. Обед. Ювелирное искусство Агры (зардози, инкрустация)." },
      { title: "День 5 · Путешествие в священный Варанаси", desc: "Трансфер на вокзал в 5:00. В 6:00 — скоростной поезд в Варанаси (завтрак и обед в поезде). Прибытие в 14:00. Размещение. В 17:00 — выезд на тук-туке в старый город: храм Каши Вишванатх, гхаты, Маникарника Гхат. Закатная лодка. Ганга Аарти на Дашвамедх Гхате." },
      { title: "День 6 · Дорога к храмам желаний — Кхаджурахо", desc: "Переезд в Кхаджурахо на автомобиле (7 часов + остановка). Размещение. Традиционный ужин с живописным видом на храмы Камасутры." },
      { title: "День 7 · Кхаджурахо — жемчужина Индии", desc: "По желанию утром — сафари в национальном парке Панна (олени, обезьяны, птицы, возможно тигры). Храмы Камасутры (ЮНЕСКО) — каменная поэма о жизни, любви и духовности. По желанию: водопад Ранех, аюрведический массаж с тёплыми маслами. Обед в ресторане с панорамным видом на храмы." },
      { title: "День 8 · Трансфер в Дели — возвращение домой", desc: "Завтрак, выселение до 11:00. Трансфер на вокзал Кхаджурахо. В 14:30 — скоростной поезд в Дели с ужином. Прибытие в 23:30. Трансфер в международный аэропорт." },
    ],
    highlights: [
      "Холи в Агре с натуральными красками и белыми одеждами",
      "Тадж-Махал и Аграский форт",
      "Форт Амбер на внедорожниках",
      "Ганга Аарти и лодка в Варанаси",
      "Храмы Камасутры в Кхаджурахо",
      "Мастер-классы: краски, окрашивание тканей, зардози",
    ],
    includes: [
      "Встреча в аэропорту Дели с гирляндой из цветов",
      "Проживание в отелях 3–4★ (2-местное размещение) с завтраками",
      "Билеты скоростного поезда 2-го класса с питанием туда-обратно",
      "Все входные билеты в монументы",
      "Комплексный ужин в Джайпуре и Кхаджурахо",
      "Комплексный обед в Джайпуре, Агре и Кхаджурахо",
      "Катание на лодке в Варанаси",
      "Велорикша в Старом Дели, тук-тук в Варанаси",
      "Мини-автобус с кондиционером и бутылочной водой",
      "Все переезды из города в город, налоги, парковки, бензин",
      "Русскоговорящий сопровождающий и водитель в каждом городе",
      "Традиционный белый костюм в Агре для празднования Холи",
      "Трансфер в аэропорт по окончании тура",
    ],
    notIncluded: [
      "Авиабилеты Москва–Дели–Москва (от $400)",
      "Виза",
      "Спектакль в Агре ($55 с чел.)",
      "Сафари в Кхаджурахо ($85 с чел., от 4 участников)",
      "Еда и напитки (обед ~$10–20/день)",
      "Личные расходы",
      "Доплата за одноместное размещение ($300)",
      "Чаевые гиду",
    ],
    organizational: [
      "Оплата ж/д билетов и отелей — рублями на карту Сбербанка за 25 дней до старта",
      "Тадж-Махал закрыт по пятницам (можно взять сари в прокат)",
      "Многие храмы Дели закрыты по понедельникам",
      "Дресс-код: закрытые плечи и колени, без шорт",
      "Хранение вещей в храмах — от 100 ₽",
      "Возможны задержки поездов по независящим причинам",
      "Предоплата невозвратна при отмене со стороны туриста",
      "Помощь с оформлением индийской e-visa (бесплатно)",
    ],
  },
  {
    id: "seekers-8day-weekly",
    title: "Индия для искателей: 8 дней от Ганга до Камасутры",
    short:
      "Для тех, кто хочет одновременно духовной и авантюрной Индии. Гибкие варианты завершения — после 5, 7 или 8 дня.",
    duration: "8 дней / 7 ночей",
    dates: "Еженедельно — каждую субботу старт из Дели",
    frequency: "weekly",
    price: "от $860 / чел.",
    priceNote: "Еженедельный заезд по субботам. Скидка -5% при ранней брони. Гибкие варианты — можно завершить тур после 5 или 7 дня, либо улететь на Гоа на 8 день.",
    city: "Дели · Джайпур · Абханери · Фатехпур Сикри · Агра · Кхаджурахо · Варанаси",
    group: "1–20 чел.",
    image: "https://customer-assets.emergentagent.com/job_seo-tour-guide/artifacts/1090iab3_IMG_20251025_143526476.webp",
    externalUrl: "https://youtravel.me/tours/52861/",
    description:
      "Индия не открывается с первого взгляда. Она притягивает, завораживает и остается внутри навсегда. Эта страна соткана из контрастов, как драгоценная парча — из золота и шёлка. Древние храмы соседствуют с шумными базарами, священный пепел смешивается с ароматом специй. В нашем туре мы не спешим: пробуем Индию на вкус, цвет и звук. Это путешествие вглубь себя. Тур ведёт русскоговорящий гид Хайдер (12+ лет опыта, родом из Агры) из команды Али.",
    longDescription: [
      "### 3 гибких варианта завершения",
      "**После 5 дня** — сразу после Золотого треугольника (Дели – Джайпур – Абханери – Фатехпур Сикри – Агра). Вы увидите главные символы Индии. **После 7 дня** — после храмов Камасутры в Кхаджурахо. **На 8 день** — из священного Варанаси вылетайте не домой, а на солнечный Гоа: сменить мистику на океан.",
      "### Ключевые моменты",
      "Огненная молитва на Ганге, аюрведический массаж, храмы Камасутры, рассвет у Тадж-Махала, спектакль «Мохаббат-э-Тадж», колодец-лабиринт Чанд Баори (3500 ступеней), деревня слонов, розовый Джайпур, велорикша по Чандни-Чоук с ласси в глиняном стакане.",
    ],
    program: [
      { title: "День 1 · Прибытие в Дели — знакомство с мегаполисом", desc: "Встреча в аэропорту у ворот №5 с гирляндой из цветов. Размещение. В 10:30 — экскурсия. Старый Дели: Красный Форт, Джама Масджид, Храм птиц, Золотая мечеть, Сис Гандж Сахиб, велорикша по Чандни-Чоук, ласси в глиняном стакане куллар. Новый Дели: Раштрапати Бхаван, Ворота Индии, Сады Лоди, Храм малаи, Акшардхам, Храм Лотоса, Храм Лакшми Нараяна. Обед в Новом Дели." },
      { title: "День 2 · Джайпур — форты, дворцы и живое ремесло", desc: "Катание на внедорожнике к Амер форту (XVI век, раджа Ман Сингх). Дворец на воде Джал-Махал, Хава-Махал (Дворец ветров), Городской дворец, обсерватория Джантар-Мантар. Ювелирная мастерская: драгоценные и полудрагоценные камни махараджей. Ковры ручной работы. Уникальный текстиль ручного окрашивания. Деревня слонов (в 20 км): кормление, купание, украшение красками, катание. Традиционный обед." },
      { title: "День 3 · Абханери → Фатехпур Сикри → Агра", desc: "Утренний выезд из Джайпура. Чанд Баори в Абханери — колодец-лабиринт XVI века глубиной 30 м с 3500 ступенями (место съёмок «Тёмного рыцаря»). Обед. Фатехпур Сикри — город-призрак Акбара (1571, столица империи, опустевшая через 14 лет из-за нехватки воды): Джама Масджид, гробница Салима Чишти, дворцовые павильоны. Вечер: прибытие в Агру." },
      { title: "День 4 · Любовь в мраморе, война в камне и ремёсла Агры", desc: "Тадж-Махал — мавзолей Шах-Джахана в память о Мумтаз-Махал. Агра-форт — стены длиной 2,5 км, дворец Мумтаз-Махал, башня, где заточённый Шах-Джахан смотрел на Тадж. Обед. Ремёсла Агры: мраморная инкрустация пиетра-дура, ювелирные изделия (Чёрная звезда Агры, звезда-рубин), вышивка зардози, шарфы из Кашмира (пашмина, шахтуш). Вечером — спектакль «Мохаббат-э-Тадж»." },
      { title: "День 5 · Переезд в Кхаджурахо на поезде", desc: "Скоростной поезд из Агры (7:45), завтрак и обед в вагоне, прибытие 14:00. Размещение в отеле. Свободное время / отдых. Ужин на крыше с видом на храмовый комплекс." },
      { title: "День 6 · Храмы Камасутры", desc: "Аюрведический массаж (по желанию). Экскурсия по храмовому комплексу Кхаджурахо (ЮНЕСКО, X век): смелые эротические барельефы, философия жизни и любви династии Чандела. Обед на крыше. По желанию: водопад Ранех, сафари в парке Панна." },
      { title: "День 7 · Переезд в Варанаси", desc: "Переезд/перелёт в Варанаси. Размещение. Вечерняя программа: тук-тук в старый город, гхаты, храм Каши Вишванатх, кремационные ритуалы Маникарника-гхата. Ганга Аарти на Дашвамедх Гхате — тысячи светильников, мантры, барабаны. Лодочная прогулка вдоль гхатов." },
      { title: "День 8 · Рассветный Ганг → Дели/Гоа", desc: "Рассветная лодка по Гангу — восход над священной рекой, купающиеся паломники, огни садху. Трансфер на скоростной поезд/самолёт в Дели или на Гоа (по выбору). Завершение тура." },
    ],
    highlights: [
      "Огненная Ганга Аарти + рассветная лодка на Ганге",
      "Храмы Камасутры в Кхаджурахо",
      "Рассвет у Тадж-Махала",
      "Спектакль «Мохаббат-э-Тадж» в Агре",
      "Чанд Баори — колодец-лабиринт в Абханери",
      "Деревня слонов под Джайпуром",
      "Форт Амбер на внедорожнике",
      "Велорикша в Старом Дели + ласси в куллар",
    ],
    includes: [
      "Встреча в аэропорту Дели с гирляндой из цветов",
      "Проживание в отелях 3–4★ (2-местное) с завтраками",
      "Русскоговорящий гид (Али / Хайдер) на весь маршрут",
      "Билеты скоростного поезда с питанием",
      "Все переезды на комфортабельном автомобиле с кондиционером",
      "Все входные билеты в монументы",
      "Комплексные обеды и ужины по программе",
      "Внедорожник в Форт Амбер, посещение деревни слонов",
      "Велорикша, тук-тук, лодка на Ганге",
      "Спектакль «Мохаббат-э-Тадж» в Агре",
      "Аюрведический массаж в Кхаджурахо",
      "Услуги водителя, все дорожные сборы, налоги, парковки, бензин",
      "Трансфер по окончании тура",
    ],
    notIncluded: [
      "Авиабилеты",
      "Виза (помощь с оформлением бесплатно)",
      "Личные расходы и напитки",
      "Сафари в парке Панна (по желанию)",
      "Доплата за одноместное размещение",
      "Чаевые гиду и водителю",
    ],
    organizational: [
      "Возможны 3 варианта окончания: после 5 дня, после 7 дня или на 8 день (с перелётом на Гоа)",
      "Тадж-Махал закрыт по пятницам",
      "Многие храмы Дели закрыты по понедельникам, дресс-код обязателен",
      "Возможны задержки поездов по независящим причинам",
      "Электронная виза оформляется бесплатно онлайн",
    ],
  },
  {
    id: "express-golden-triangle-3d",
    title: "Эксклюзивный экспресс-тур: Золотой треугольник Индии за 3 дня",
    short: "Дели, Агра и Джайпур за 3 дня — максимум впечатлений в комфортном формате: отели 3–4★, кондиционированный транспорт, русскоговорящий гид, встреча с гирляндой из бархатцев и жасмина.",
    duration: "3 дня",
    dates: "Еженедельно по средам",
    frequency: "weekly",
    price: "$549 / чел.",
    priceNote: "Еженедельный заезд по средам. Одноместное размещение — доплата $150.",
    city: "Дели · Агра · Джайпур",
    group: "1–20 чел.",
    image: "https://cf.youtravel.me/tr:w-1200/public/images/tour/media/2025/06/05/4629c477bda492251560d240c02363081f9de4a5.jpg",
    externalUrl: "https://youtravel.me/tours/62464/",
    description:
      "Три дня, три города, три эпохи. Дели, Агра и Джайпур — легендарный Золотой треугольник Индии в самом насыщенном формате. Первый вдох страны — гирлянда из свежих бархатцев и жасмина на выходе из аэропорта. Дальше — рассветный Тадж-Махал, прогулка на слоне к форту Амбер, ювелирные мастерские Моголов и раджастанские танцы под звёздами. Формат экспресс идеально подходит для первого знакомства с Индией.",
    longDescription: [
      "### Что вас ждёт",
      "Настоящий контраст двух Дели — хаотичного Старого с базаром Чандни-Чоук и величественного Нового с проспектами Раджпатха. Рассветный Тадж-Махал, когда мрамор из молочно-белого становится сначала розовым, а потом золотым. Королевский подъём на слоне к форту Амбер под пение погонщиков. Прощальный ужин с раджастанской музыкой, барабанами дхол и танцовщицами в развевающихся чунри.",
      "### Формат",
      "Русскоговорящий гид, комфортабельные отели 3–4★ с завтраками, автомобиль или минивэн с кондиционером на всём маршруте. Все переезды между городами и все входные билеты уже включены.",
    ],
    program: [
      {
        title: "День 1 · Дели — где время пульсирует в ритме вечности",
        desc:
          "Традиционная встреча: самолёт касается земли, и Индия раскрывает объятия. В прохладе аэропорта вас встречает ослепительная гирлянда из свежих бархатцев и белоснежного жасмина — сладкий, пьянящий аромат первого вдоха Индии.\n\n" +
          "Старый Дели · хаос и величие. Погружаемся в пульсирующее сердце истории. Узкие улочки сплетаются в лабиринт, где жизнь бурлит неудержимо. Воздух гудит от криков торговцев на легендарном базаре Чандни-Чоук, звонков рикш и запахов специй. Среди этого живого хаоса возвышаются суровые стены Красного Форта и величественные минареты Джама-Масджид — самой большой мечети Индии, откуда открывается захватывающий вид на старый город.\n\n" +
          "Новый Дели · ширь и гармония. Резкий контраст: широкие тенистые проспекты Раджпатх, белоснежный Храм Лотоса, парящий над землёй как гигантский бутон, и монументальные Ворота Индии — молчаливый страж на перекрёстке времён.\n\n" +
          "Секретный лайфхак: после насыщенного дня — секретный ресторан, где готовят, возможно, самый восхитительный баттер-чикен в стране. Нежнейшее куриное филе в бархатистом пряно-сливочном соусе — гастрономический символ вашего первого дня.\n\n" +
          "Вечерний переезд в Агру. За окном проплывают золотистые в закатных лучах поля, силуэты деревенек. В воздухе — сладкое предвкушение: завтра вас ждёт встреча с одним из Чудес Света.",
      },
      {
        title: "День 2 · Агра — эхо вечной страсти",
        desc:
          "Тадж-Махал на рассвете. Воздух прохладен и прозрачен. Первые лучи солнца — нежно-розовые, затем золотые — медленно скользят по белоснежному мрамору, словно оживляя его. Мавзолей парит над гладью водного канала, отражаясь в нём как сказочное видение. Тишину нарушает лишь щебет птиц и шёпот гидов, передающих легенду о безутешном Шах-Джахане и его любимой Мумтаз-Махал.\n\n" +
          "Агра-форт. Мощные красные стены вздымаются над рекой Ямуна. Внутри — лабиринт дворцов, залов и мечетей. Стоя перед роскошным Диван-и-Ам, легко представить императора, вершащего судьбы империи. Заглядываем в полутёмные переходы гарема и выходим к окнам Мусамман-Бурдж — той самой октагональной башне, откуда пленённый Шах-Джахан в последние годы жизни смотрел на Тадж вдалеке.\n\n" +
          "Мастер-класс для души — ювелиры Моголов. В прохладном полумраке мастерской мастер показывает древние техники кундан и минакари: сверкание крошечных рубинов, изумрудов и бриллиантов, звон молоточков — на ваших глазах из золота и самоцветов рождается украшение.\n\n" +
          "Искусство пьетра-дура. В другой мастерской пахнет мраморной пылью. Наблюдаем, как тончайшие пластинки лазурита, сердолика и малахита вкладываются в мрамор. Под руководством мастера пробуем свои силы и уносим маленькую шкатулку или подставку с собственным узором.\n\n" +
          "Переезд в Джайпур. Дорога петляет сквозь живописные деревни: женщины в ярких сари несут кувшины, буйволы нежатся в прудах, поля сменяются чайными плантациями. Постепенно ощущение древности сменяется предвкушением встречи с розовой столицей Раджастана.",
      },
      {
        title: "День 3 · Джайпур — где розовый камень шепчет историю",
        desc:
          "Восхождение к величию · форт Амбер. Утро начинается с истинно королевского жеста — плавного подъёма на исполинских слонах к вратам форта. Каждый шаг могучего животного отдаётся эхом в горах. Массивные крепостные стены цвета закатной охры возвышаются над озером Маота, отражаясь в его зеркальной глади. Внутри — лабиринт дворцовых залов, где игра света в зеркалах Шиш-Махала создаёт иллюзию звёздного неба даже днём.\n\n" +
          "Лик без лица · Хава-Махал (Дворец Ветров). Гигантский ажурный фасад, похожий на сказочную корону из песчаника. 953 изящных оконца-джали, словно глаза невидимых обитательниц гарема, позволяют заглянуть в прошлое. Прохладный ветерок «хава» гулял по коридорам, а решётки скрывали от посторонних взглядов женщин королевской семьи.\n\n" +
          "Диалог со Вселенной · Джантар-Мантар. Обсерватория XVIII века — не руины, а гигантские точнейшие каменные инструменты гения Савай Джай Сингха II. Ходим среди исполинских солнечных часов Самрат-Янтра и колёс для вычисления положения звёзд — рукопожатие с древними астрономами.\n\n" +
          "В царстве лесных духов · Храм обезьян Галтаджи. Комплекс приютился в горном ущелье. Храмовые павильоны каскадом спускаются по склону, питаемые природными источниками. Стаи почитаемых обезьян-лангуров резвятся у священных водоёмов и бесстрашно выпрашивают угощения.\n\n" +
          "Раджастанское прощание · танец огня и цвета. Прощальный ужин под открытым небом: могучее пение местных артистов, виртуозная игра на народных инструментах, завораживающие танцы. Певучие движения танцовщиц, яркие развевающиеся шарфы чунри, барабаны дхол — вихрь цвета, звука и эмоций, незабываемая точка вашего путешествия.",
      },
    ],
    highlights: [
      "Тадж-Махал на рассвете",
      "Королевский подъём на слоне к форту Амбер",
      "Хаос и цвет Старого Дели (Чандни-Чоук, Красный Форт, Джама-Масджид)",
      "Мастер-классы: ювелиры Моголов и пьетра-дура",
      "Хава-Махал, Джантар-Мантар и Храм обезьян Галтаджи",
      "Прощальный ужин с раджастанской музыкой и танцами",
    ],
    includes: [
      "Проживание в отелях 3–4★ с завтраками",
      "Прогулка на слоне в Джайпуре у форта Амбер",
      "Катание на велорикше в Старом Дели",
      "Все трансферы на авто с кондиционером",
      "Входные билеты в монументы",
      "Услуги русскоговорящего гида и водителя",
      "Цветы, чайные церемонии, приятные сюрпризы",
    ],
    notIncluded: [
      "Питание и напитки",
      "Любые дополнительные экскурсии",
      "Чаевые гиду и водителю",
      "Доплата за одноместное размещение — $150",
    ],
    organizational: [
      "Дни закрытия: Тадж-Махал не работает по пятницам; Храм Лотоса и Акшардхам — по понедельникам",
      "Дресс-код в храмах: закрытые плечи и колени; удобная обувь, которую легко снимать",
      "Имейте при себе наличные (USD или EUR) — для мелких покупок, чаевых и мест, где не принимают карты",
      "При одном участнике прогулка на слоне не входит в стоимость",
      "Доплата за одноместное размещение — $150",
      "Предоплата за бронирование отелей — заранее тур-организатору (RUB или INR)",
      "Предоплата за отели невозвратна в случае отмены поездки",
    ],
  },
  {
    id: "girls-only-4d",
    title: "Только для девочек: 4 незабываемых дня в кругу подруг",
    short: "Идеальный девичник в Индии — сари, Тадж-Махал, прогулка на слоне, аюрведический массаж, дворцы Джайпура. Всё для незабываемых фото и эмоций.",
    duration: "4 дня / 3 ночи",
    dates: "Еженедельно — старт из Дели по средам",
    frequency: "weekly",
    price: "от $540 / чел.",
    priceNote: "Еженедельный заезд по средам. Идеально для компании подруг.",
    city: "Дели · Агра · Джайпур",
    group: "1–20 чел.",
    image: "https://cf.youtravel.me/tr:w-1200/upload/tours/d39/t20lw0xn35w5fv3mcfwu9mc0rgkmslv5.jpg",
    externalUrl: "https://youtravel.me/tours/30859/",
    description:
      "Исполните свою мечту в сиянии Индии! Представьте себя в роскошном традиционном сари на фоне величественного Тадж-Махала. Это не просто фото — это воплощение элегантности и волшебства. Тур создан специально для тех, кто хочет познакомиться с культурным богатством Индии в компании подруг.",
    program: [
      { title: "День 1 · Агра — город любви и величия", desc: "Встреча в аэропорту Дели, переезд в Агру (~3 часа). Завтрак. Салон сари: подбор и облачение в традиционный костюм. Тадж-Махал — фотосессия у чуда света. Аграский форт из красного песчаника. Обед в лучшем ресторане. Вечером — спектакль «Мохаббат-э-Тадж»." },
      { title: "День 2 · Скрытые жемчужины Агры + переезд в Джайпур", desc: "Бэби Тадж (Итимад-уд-Даула) — прообраз великого мавзолея. Лунный сад Мехтаб-Баг — Тадж с другого берега Ямуны. Аюрведический комплекс (60 мин): Абхьянга + Широдхара + поттали массаж с целебными травами. Обед. Переезд в Джайпур (4 часа)." },
      { title: "День 3 · Джайпур — Розовая жемчужина Раджастана", desc: "Амберский форт с прогулкой на слоне. Джал-Махал (Дворец на воде). Хава-Махал (Дворец Ветров). Городской дворец и Джантар-Мантар. Обед под народные раджастанские мелодии. Вечерний переезд в Дели." },
      { title: "День 4 · Дели — город контрастов", desc: "Старый Дели: Джама Масджид, Чандни-Чоук, Красный Форт, Гурудвара Сис Гандж Сахиб. Новый Дели: Раджпатх, Сад Лодхи, Акшардхам, Храм Лотоса, Аграсен Ки Баоли, Ворота Индии, Раштрапати-Бхаван. Прощальный обед и трансфер в аэропорт." },
    ],
    highlights: [
      "Фотосессия в сари у Тадж-Махала",
      "Королевская прогулка на слоне в Джайпуре",
      "Аюрведический массаж в Агре",
      "Танцы под звёздами в Джайпуре",
      "Мистический вечер в Акшардхаме",
      "Спектакль «Мохаббат-э-Тадж»",
    ],
    includes: [
      "Встреча в аэропорту Дели",
      "Проживание в отелях 3–4★ с завтраками",
      "Машина с кондиционером",
      "Все входные билеты в монументы",
      "Прогулка на слоне в Джайпуре",
      "Аюрведический массаж в Агре (60 мин)",
      "Прокат сари в Агре",
      "Все дороги, налоги, парковки, бензин",
      "Русскоговорящий гид и водитель",
      "Трансфер в аэропорт по окончании тура",
    ],
    notIncluded: [
      "Авиабилеты",
      "Виза (помощь с оформлением)",
      "Еда и напитки",
      "Спектакли и дополнительные экскурсии",
      "Личные расходы",
    ],
    organizational: [
      "Тадж-Махал закрыт по пятницам",
      "Акшардхам и Храм Лотоса — по понедельникам",
      "В храмах Дели снимают обувь, дресс-код обязателен",
      "В сикхских храмах ходят босиком",
      "Удобная обувь — обязательно",
    ],
  },
  {
    id: "golden-triangle-north-4d",
    title: "Золотой треугольник Северной Индии: путешествие сквозь века",
    short: "Расширенный маршрут Золотого треугольника с Фатехпур-Сикри и ступенчатым колодцем Чанд Баори. 4 дня погружения в эпоху Великих Моголов.",
    duration: "4 дня / 3 ночи",
    dates: "Еженедельно — ежедневный старт из Дели",
    frequency: "weekly",
    price: "от $590 / чел.",
    priceNote: "Ежедневный старт из Дели. Отели 3–4★ с завтраками.",
    city: "Дели · Агра · Фатехпур Сикри · Абханери · Джайпур",
    group: "1–20 чел.",
    image: "https://cf.youtravel.me/tr:w-1200/public/images/tour/media/2025/06/04/6ad72e040f206f6e239b972f662e3f7e142703c5.jpg",
    externalUrl: "https://youtravel.me/tours/62388/",
    description:
      "Погрузитесь в сияние веков! Четыре незабываемых дня, где сама история оживёт перед вами в калейдоскопе Золотого треугольника Северной Индии. Расширенный маршрут: пышущий энергией Дели, город вечной любви Агра, розовая сказка Джайпура, тайны покинутой столицы Фатехпур-Сикри и инженерное чудо Чанд Баори.",
    program: [
      { title: "День 1 · Ожерелье Агры — от врат Индии к вечной любви", desc: "Встреча в аэропорту с гирляндами (ритуал Свагат). Переезд в Агру (~200 км). Завтрак в отеле 4★. Тадж-Махал — застывшая поэзия в мраморе. Аграский форт — цитадель власти Акбара Великого. Мастерские Агры: ювелирный салон, фабрика пьетра-дура (мастер-класс), фабрика пашмины. Вечером — спектакль «Мохаббат-э-Тадж»." },
      { title: "День 2 · Фатехпур-Сикри и Чанд Баори — эхо империй", desc: "Фатехpur-Сикри — город-призрак Акбара: Джама Масджид, Буланд Дарваза (54 м, Ворота Победы), Диван-и-Ам, Диван-и-Кхас, Панч Махал. Абханери — Чанд Баори: один из самых глубоких ступенчатых колодцев мира (3500 ступеней, IX век). Храм Харшат Мата. Обед. Переезд в Джайпур." },
      { title: "День 3 · Джайпур — от форта Амбер до звёзд Джантар-Мантар", desc: "Форт Амбер — владыка холмов, прогулка на слоне. Джал-Махал — мираж на воде. Городской дворец с музеями. Хава-Махал (Дворец Ветров) — 953 окна. Фабрика окраски текстиля (мастер-класс). Фабрика ковров ручной работы. Обсерватория Джантар-Мантар (ЮНЕСКО). Вечерний переезд в Дели." },
      { title: "День 4 · Дели — минареты, базары и вечность", desc: "Старый Дели: Джама Масджид, велорикша по Чандни-Чоук, Красный Форт. Новый Дели: Акшардхам или Храм Лотоса, Ворота Индии, Раштрапати-Бхаван, Сад Лодхи. Прощальный обед. Трансфер в аэропорт." },
    ],
    highlights: [
      "Тадж-Махал на рассвете",
      "Город-призрак Фатехпур-Сикри и Буланд Дарваза",
      "Ступенчатый колодец Чанд Баори (3500 ступеней)",
      "Прогулка на слоне к форту Амбер",
      "Мастер-класс по пьетра-дура в Агре",
      "Хава-Махал и Джантар-Мантар",
      "Спектакль «Мохаббат-э-Тадж»",
    ],
    includes: [
      "Встреча в аэропорту Дели с гирляндой",
      "Проживание в отелях 3–4★ с завтраками",
      "Все трансферы на авто с кондиционером",
      "Входные билеты в монументы",
      "Прогулка на слоне в форте Амбер",
      "Мастер-класс по пьетра-дура",
      "Опытный русскоговорящий гид",
      "Все дороги, налоги, парковки, бензин",
      "Трансфер в аэропорт по окончании тура",
    ],
    notIncluded: [
      "Авиабилеты",
      "Виза",
      "Обеды и ужины",
      "Напитки",
      "Спектакль «Мохаббат-э-Тадж» ($55)",
      "Личные расходы и чаевые",
    ],
    organizational: [
      "Тадж-Махал закрыт по пятницам",
      "Дресс-код в храмах обязателен",
      "Индийская e-visa оформляется онлайн бесплатно",
      "Возможны задержки в дороге из-за трафика",
    ],
  },
];

export const REVIEWS = [
  {
    name: "Ольга и Максим",
    city: "Москва",
    text: "Али — золотой человек. Три дня Золотого треугольника прошли как в кино: рассвет у Тадж-Махала, слоны в Джайпуре, ужины в семьях. Русский у Али отличный, всё чётко и без суеты.",
    stars: 5,
  },
  {
    name: "Ирина",
    city: "Санкт-Петербург",
    text: "Транзитный тур из аэропорта за 8 часов — это спасение. Успели увидеть Дели, поесть настоящую индийскую еду и вернуться на рейс. Али встретил и проводил.",
    stars: 5,
  },
  {
    name: "Семья Кузнецовых",
    city: "Екатеринбург",
    text: "Ездили с двумя детьми в Джайпур и Пушкар. Али учёл всё: детское меню, остановки, интересный формат рассказа. Дети до сих пор вспоминают верблюдов и слонов.",
    stars: 5,
  },
  {
    name: "Анна",
    city: "Казань",
    text: "Ночной Дели с Али — совсем другой город. Мы, две девушки, чувствовали себя в полной безопасности. Уличная еда — топ, ни у кого не заболел живот.",
    stars: 5,
  },
  {
    name: "Дмитрий",
    city: "Новосибирск",
    text: "Заказывал у Али индивидуальный маршрут по Раджастану: Джайпур, Джодхпур, Удайпур. Всё под ключ — водители, отели, входные билеты. Ни одной накладки, всё точно в срок.",
    stars: 5,
  },
  {
    name: "Марина",
    city: "Краснодар",
    text: "Фотосессия в сари в Джайпуре — лучшее решение поездки. Стилист, локации, обработка — как в глянце. Спасибо, Али, за организацию.",
    stars: 5,
  },
];

export const FAQ = [
  {
    q: "На каком языке проводятся экскурсии?",
    a: "Все экскурсии проходят на русском языке. Али свободно говорит по-русски более 12 лет — он лично сопровождает большинство групп и туров.",
  },
  {
    q: "Как забронировать экскурсию?",
    a: "Заполните форму заявки на сайте, напишите в WhatsApp или Telegram. Али ответит в течение 1–2 часов и подтвердит все детали.",
  },
  {
    q: "Нужна ли предоплата?",
    a: "Для однодневных экскурсий — нет, оплата на месте. Для многодневных туров и туров с отелями — предоплата 20–30% для брони отелей и билетов.",
  },
  {
    q: "Что делать, если у меня нет визы?",
    a: "Али подскажет актуальные правила по электронной визе e-Visa India — процесс занимает 3–5 рабочих дней и делается онлайн.",
  },
  {
    q: "Безопасно ли путешествовать по Индии?",
    a: "С частным гидом — да. Али сопровождает вас с момента выхода из аэропорта: проверенные водители, отели и рестораны, поддержка 24/7 на русском.",
  },
];
